import {
    IsNotEmpty,
    IsBoolean,
    IsOptional,
    IsIn,
    IsInt,
    Min,
    Max,
    Length,
    Matches,
    MaxLength,
    ValidateIf,
    IsArray,
    ValidateNested,
    IsEmail
} from "class-validator";
import { Type } from "class-transformer";
/*
 * This file is auto-generated. Do NOT modify this file manually.
 */
type OperationWithoutBody = (
    path: string,
    query: {
        [key: string]: any;
    }
) => Promise<any>;
type OperationWithBody = (
    path: string,
    body: any,
    query: {
        [key: string]: any;
    }
) => Promise<any>;
export interface HTTPClient {
    get: OperationWithoutBody;
    post: OperationWithBody;
    put: OperationWithBody;
    delete: OperationWithoutBody;
    patch: OperationWithBody;
    setHeaders: (headers: { [key: string]: string }) => void;
}
export type GetHealthCheckResponseBody = {
    status: number;
    from: string;
    environment: string;
};
export type GetVersionsResponseBody = {
    apiVersion: string;
    minAppVersion: string;
};
export type S3 = {
    url: string;
    key: string;
};
export type GetSignedUrlResponseBody = S3;
export type DocumentReviewType = typeof DocumentReviewType[keyof typeof DocumentReviewType];
export type GetSignedUrlConfidentialRequestBody = {
    isIdentify: boolean;
    documentType?: DocumentReviewType;
};
export type GetSignedUrlConfidentialResponseBody = S3;
export type GetS3SignedUrlInConciergeChatRequestBody = {
    width: number;
    height: number;
};
export type GetS3SignedUrlInConciergeChatResponseBody = S3;
export type GetDownloadS3SignedUrlInConciergeChatQuery = {
    filename: string;
};
export type ConciergeChatImageEnum = typeof ConciergeChatImageEnum[keyof typeof ConciergeChatImageEnum];
export type ConciergeChatImage = {
    type: ConciergeChatImageEnum;
    s3Url: string;
    filename: string;
    height: number;
    width: number;
};
export type GetDownloadS3SignedUrlInConciergeChatResponseBody = ConciergeChatImage;
export type GetMyNoticesQuery = {
    page?: number;
};
export type UserNotice = {
    id: number;
    title: string;
    body: string;
    isSeen: boolean;
    noticeTime: string;
};
export type MyNoticesByDay = {
    day: string;
    records: UserNotice[];
};
export type GetMyNoticesResponseBody = {
    notices: MyNoticesByDay[];
    hasNext: boolean;
};
export type CounselingType = typeof CounselingType[keyof typeof CounselingType];
export type PostCounselingReservationRequestBody = {
    counselingType?: CounselingType;
    counselingMethod?: string;
    firstPreferredDate: string;
    firstPreferredTime?: string;
    secondPreferredDate?: string;
    secondPreferredTime?: string;
    thirdPreferredDate?: string;
    thirdPreferredTime?: string;
};
export type PostCounselingReservationResponseBody = {
    success: boolean;
};
export type PostCounselingVideoResponseBody = {
    success: boolean;
};
export type UserSettings = {
    userId: string;
    reviewResultEmail: boolean;
    likeEmail: boolean;
    matchingEmail: boolean;
    messageEmail: boolean;
    noticeEmail: boolean;
    reviewResultPush: boolean;
    likePush: boolean;
    matchingPush: boolean;
    messagePush: boolean;
    noticePush: boolean;
    mutePushStartHour: number | null;
    mutePushEndHour: number | null;
    createdDate: string | Date;
    updatedDate: string | Date;
};
export type GetMySettingsResponseBody = UserSettings;
export type PutMySettingsRequestBody = {
    reviewResultEmail: boolean;
    likeEmail: boolean;
    matchingEmail: boolean;
    messageEmail: boolean;
    noticeEmail: boolean;
    reviewResultPush: boolean;
    likePush: boolean;
    matchingPush: boolean;
    messagePush: boolean;
    noticePush: boolean;
    mutePushStartHour?: number;
    mutePushEndHour?: number;
};
export type PutMySettingsResponseBody = UserSettings;
export type PutMySettingsPushNotificationsRequestBody = {
    token: string;
};
export type PutMySettingsPushNotificationsResponseBody = {
    success: boolean;
};
export type PutMySettingsPhoneRequestBody = {
    phone: string;
};
export type PutMySettingsPhoneResponseBody = {
    success: boolean;
};
export type PutMyNoticeSeenRequestBody = {
    lastSeenNoticeId: number;
};
export type PutMyNoticeSeenResponseBody = {
    success: boolean;
};
export type IdentifyReviewReject = {
    isCertificateSubmitted?: boolean;
    rejectCount?: number;
    rejectReason?: {
        nickname?: string[];
        photo?: string[];
        certificate?: string[];
        birthday?: string[];
        fullname?: string[];
        address?: string[];
    };
    rejectComment?: string | null;
};
export type GetIdentifyReviewRejectResponseBody = IdentifyReviewReject;
export type PutIdentifyReviewRequestBody = {
    identifyCertificate?: string | null;
    identifyCertificateBack?: string | null;
};
export type IdentifyReview = {
    identifyCertificate?: string | null;
    identifyCertificateBack?: string | null;
    rejectReason?: number[] | null;
    rejectCount?: number;
    rejectComment?: string | null;
};
export type PutIdentifyReviewResponseBody = IdentifyReview;
export type PatchIdentifyReviewResubmitResponseBody = IdentifyReview;
export type PostDocumentReviewRequestBody = {
    type: DocumentReviewType;
    value?: number | null;
    filename: string;
    filename2?: string;
    filename3?: string;
};
export type PostDocumentReviewResponseBody = {
    success: boolean;
};
export type VerifyReceiptRequestBody = {
    receipt: string;
    platform: string;
};
export type VerifyReceiptResponseBody = {
    status: string;
};
export type UserProfile = {
    userId: string;
    pref?: number | null;
    bornPref?: number | null;
    height?: number | null;
    figure?: number | null;
    marriage?: number | null;
    occupation?: number | null;
    wantChild?: number | null;
    hasChild?: number | null;
    childLiveTogether?: number;
    childCustody?: number;
    childPaySupport?: number;
    officeName?: string | null;
    jobName?: string | null;
    annualIncome?: number | null;
    education?: number | null;
    schoolName?: string | null;
    selfPr?: string | null;
    bloodType?: number | null;
    familyRelationship?: number | null;
    liveWithParent?: number | null;
    jobDivision?: number | null;
    drink?: number | null;
    smoke?: number | null;
    hobby?: number[];
    hobbyObsession?: string | null;
    wantToDo?: string | null;
    likeThing?: string | null;
    dislikeThing?: string | null;
    idealMarriage?: string | null;
    comment?: string | null;
    marriageTiming?: number | null;
    housework?: number | null;
    parenting?: number | null;
    holiday?: number | null;
    language?: number[];
    activatedDate?: (string | Date) | null;
    unmarriedStatusVerified?: boolean;
    annualIncomeVerified?: boolean;
    educationVerified?: boolean;
    occupationVerified?: boolean;
    faceType?: number | null;
    faceTypeTarget?: number | null;
    eqType?: number | null;
    eqTypeTarget?: number | null;
    createdDate?: (string | Date) | null;
    updatedDate?: (string | Date) | null;
};
export type UserPublicPhoto = {
    filename: string;
    small: string;
    medium: string;
    large: string;
};
export type RejectReason = typeof RejectReason[keyof typeof RejectReason];
export type ProfileReview = {
    userId: string;
    nickname: string | null;
    address?: string | null;
    mainPhoto: UserPublicPhoto | null;
    comment: string | null;
    selfPr: string | null;
    hobbyObsession: string | null;
    wantToDo: string | null;
    likeThing: string | null;
    dislikeThing: string | null;
    idealMarriage: string | null;
    officeName: string | null;
    jobName: string | null;
    schoolName: string | null;
    checked: boolean;
    photosChecked: boolean;
    cShipPhotoNgReasons?: RejectReason[];
    cShipPhotoNg?: boolean;
    reviewingPhotoIsFromCShipPhotoScreen?: boolean;
    registeredFromCShipPhotoScreen?: boolean;
    createdDate: string | Date;
    updatedDate: string | Date;
};
export type Gender = typeof Gender[keyof typeof Gender];
export type MyPhoto = {
    filename: string;
    small: string;
    medium: string;
    large: string;
    status: number;
};
export type User = {
    userId: string;
    nickname?: string;
    userProfile?: UserProfile;
    profileReview: ProfileReview;
    gender?: Gender;
    mainPhoto: UserPublicPhoto | null;
    externalId?: string | null;
    subPhotos?: MyPhoto[];
    status: number;
    birthday?: string;
    familyName?: string;
    givenName?: string;
    familyNameKana?: string;
    givenNameKana?: string;
    address?: string;
    phone?: string;
    weight?: number;
    zip?: string;
    lastLoginDate?: string | Date;
    isPaid?: boolean;
    singleCertAgentApplied?: boolean;
    age?: number;
    identifyStatus?: number;
    unmarriedVerifiedStatus?: number;
    incomeVerifiedStatus?: number;
    educationVerifiedStatus?: number;
    occupationVerifiedStatus?: number;
    cShipId?: number;
    cShipNo?: string;
    cShipStatus?: number;
    conciergeProfileId?: number;
    onboardingStatus?: {
        hasPartnerCondition?: boolean;
        hasMarriageActivityStatus?: boolean;
    };
    showAppReviewDialog?: boolean;
    createdDate: string | Date;
    updatedDate: string | Date;
};
export type GetMyUserResponseBody = User | null;
export type Prefecture = typeof Prefecture[keyof typeof Prefecture];
export type UserCreateParams = {
    nickname: string;
    phone: string;
    gender: Gender;
    birthday: string;
    pref: Prefecture | null;
};
export type PostMyUserRequestBody = UserCreateParams;
export type PostMyUserResponseBody = User;
export type UserUpdateParams = {
    mainPhoto: string | null;
    subPhotos: string[];
    nickname: string;
    weight?: number;
    address?: string;
    phone: string;
    zip?: string;
};
export type PatchMyUserRequestBody = UserUpdateParams;
export type PatchMyUserResponseBody = {
    success: boolean;
};
export type PostPaidRegisterUserRequestBody = {
    nickname: string;
    familyName: string;
    givenName: string;
    familyNameKana: string;
    givenNameKana: string;
    birthday: string;
    gender: Gender;
    phone: string;
    zip: string;
    pref: Prefecture;
    city: string;
    address: string;
    building?: string | null;
};
export type PostPaidRegisterUserResponseBody = User;
export type SearchUser = {
    userId: string;
    cShipNo?: string | null;
    cShipSsoLink?: string | null;
    nickname?: string;
    gender: Gender;
    age: number;
    pref?: number;
    bornPref?: number;
    mainPhoto?: UserPublicPhoto;
    subPhotos?: UserPublicPhoto[];
    activeStatus: number;
    isNewUser?: boolean;
    isIdentified?: boolean;
    isAllDocumentApproved?: boolean;
    unmarriedStatusVerified?: boolean;
    annualIncomeVerified?: boolean;
    educationVerified?: boolean;
    isOnlyCShipMember?: boolean;
    isPaid?: boolean;
    isCShip?: boolean;
    matchScore: number | null;
    height?: number | null;
    figure?: number;
    marriage?: number;
    wantChild?: number;
    hasChild?: number;
    childLiveTogether?: number;
    childCustody?: number;
    childPaySupport?: number;
    officeName?: string;
    occupation?: number;
    jobName?: string;
    annualIncome?: number | null;
    education?: number | null;
    schoolName?: string;
    selfPr?: string;
    bloodType?: number;
    familyRelationship?: number;
    liveWithParent?: number | null;
    drink?: number;
    smoke?: number;
    hobby?: number[];
    hobbyObsession?: string;
    wantToDo?: string;
    likeThing?: string;
    dislikeThing?: string;
    idealMarriage?: string;
    comment: string;
    marriageTiming?: number;
    housework?: number;
    parenting?: number;
    holiday?: number | null;
    language?: number[];
    myLikeDate?: (string | Date) | null;
    likeMeDate?: (string | Date) | null;
    eqType?: number | null;
};
export type GetMySearchUserResponseBody = SearchUser;
export type Height = typeof Height[keyof typeof Height];
export type Figure = typeof Figure[keyof typeof Figure];
export type MaritalStatus = typeof MaritalStatus[keyof typeof MaritalStatus];
export type Occupation = typeof Occupation[keyof typeof Occupation];
export type WantChildren = typeof WantChildren[keyof typeof WantChildren];
export type HasChildren = typeof HasChildren[keyof typeof HasChildren];
export type ChildLiveTogether = typeof ChildLiveTogether[keyof typeof ChildLiveTogether];
export type ChildCustody = typeof ChildCustody[keyof typeof ChildCustody];
export type ChildPaySupport = typeof ChildPaySupport[keyof typeof ChildPaySupport];
export type AnnualIncomeRange = typeof AnnualIncomeRange[keyof typeof AnnualIncomeRange];
export type EducationLevel = typeof EducationLevel[keyof typeof EducationLevel];
export type BloodType = typeof BloodType[keyof typeof BloodType];
export type FamilyRelationship = typeof FamilyRelationship[keyof typeof FamilyRelationship];
export type LiveWithParent = typeof LiveWithParent[keyof typeof LiveWithParent];
export type JobDivision = typeof JobDivision[keyof typeof JobDivision];
export type Drinking = typeof Drinking[keyof typeof Drinking];
export type Smoking = typeof Smoking[keyof typeof Smoking];
export type Hobby = typeof Hobby[keyof typeof Hobby];
export type MarriageTiming = typeof MarriageTiming[keyof typeof MarriageTiming];
export type HouseWork = typeof HouseWork[keyof typeof HouseWork];
export type Parenting = typeof Parenting[keyof typeof Parenting];
export type Holiday = typeof Holiday[keyof typeof Holiday];
export type Language = typeof Language[keyof typeof Language];
export type FaceType = typeof FaceType[keyof typeof FaceType];
export type EQ = typeof EQ[keyof typeof EQ];
export type UserCanEditProfile = {
    pref?: Prefecture | null;
    bornPref?: Prefecture | null;
    height?: Height;
    figure?: Figure | null;
    marriage?: MaritalStatus;
    occupation?: Occupation | null;
    wantChild?: WantChildren | null;
    hasChild?: HasChildren | null;
    childLiveTogether?: ChildLiveTogether;
    childCustody?: ChildCustody;
    childPaySupport?: ChildPaySupport;
    officeName?: string | null;
    jobName?: string | null;
    annualIncome?: AnnualIncomeRange;
    education?: EducationLevel | null;
    schoolName?: string | null;
    selfPr?: string | null;
    bloodType?: BloodType | null;
    familyRelationship?: FamilyRelationship | null;
    liveWithParent?: LiveWithParent | null;
    jobDivision?: JobDivision | null;
    drink?: Drinking | null;
    smoke?: Smoking;
    hobby?: Hobby[];
    hobbyObsession?: string | null;
    wantToDo?: string | null;
    likeThing?: string | null;
    dislikeThing?: string | null;
    idealMarriage?: string | null;
    comment?: string | null;
    marriageTiming?: MarriageTiming | null;
    housework?: HouseWork | null;
    parenting?: Parenting | null;
    holiday?: Holiday | null;
    language?: Language[];
    faceType?: FaceType | null;
    faceTypeTarget?: FaceType | null;
    eqType?: EQ | null;
    eqTypeTarget?: EQ | null;
};
export type UserAddressParams = {
    zip: string;
    pref: Prefecture;
    city: string;
    address: string;
    building?: string;
};
export type MyUserBasicInfo = {
    mainPhoto?: string;
    familyName?: string;
    givenName?: string;
    familyNameKana?: string;
    givenNameKana?: string;
    nickname?: string;
    birthday?: string;
    userProfile?: UserCanEditProfile;
    userAddress?: UserAddressParams;
};
export type PutMyUserBasicInfoRequestBody = MyUserBasicInfo;
export type PutMyUserBasicInfoResponseBody = User;
export type PutPhotoForCShipRequestBody = {
    mainPhoto: string;
};
export type PutPhotoForCShipResponseBody = User;
export type PutMyUserProfileRequestBody = UserCanEditProfile;
export type PutMyUserProfileResponseBody = {
    success: boolean;
};
export type RequestParticipateCShipResponseBody = {
    success: boolean;
};
export type GetCShipSsoLoginUrlResponseBody = {
    url: string;
};
export type PostCShipRegisterCheckResponseBody = {
    available: boolean;
    invalidItems: string[];
    unmarriedStatusVerified: boolean;
    annualIncomeVerified: boolean;
    educationVerified: boolean;
    occupationVerified: boolean;
    isPaid: boolean;
};
export type PostAvCongenialityAnswerRequestBody = {
    answer: number[];
};
export type PostAvCongenialityAnswerResponseBody = {
    success: boolean;
};
export type PostVfCongenialityAnswerRequestBody = {
    answer: number[];
};
export type PostVfCongenialityAnswerResponseBody = {
    success: boolean;
};
export type PostAuthLoginRequestBody = {
    email: string;
    isSignUp: boolean;
};
export type PostAuthLoginResponseBody = {
    success: boolean;
};
export type PostAuthCodeRequestBody = {
    email: string;
    code: string;
};
export type PostAuthCodeResponseBody = {
    authToken: string;
};
export type PutNewEmailLoginRequestBody = {
    newEmail: string;
};
export type PutNewEmailLoginResponseBody = {
    success: boolean;
};
export type PutNewEmailCodeRequestBody = {
    newEmail: string;
    code: string;
};
export type PutNewEmailCodeResponseBody = {
    authToken: string;
};
export type GetUsersQuery = {
    lastSortUserId?: string;
    lastSortValue?: number;
    isPaid?: boolean;
    isCShip?: boolean;
    sortType?: number;
    residences?: number[];
    birthplaces?: number[];
    ageFrom?: number;
    ageTo?: number;
    heightsFrom?: number;
    heightsTo?: number;
    figures?: number[];
    bloodTypes?: number[];
    occupations?: number[];
    incomeFrom?: number;
    incomeTo?: number;
    educations?: number[];
    maritalStatuses?: number[];
    hasChildren?: number;
    houseworks?: number[];
    wantChildren?: number[];
    parentings?: number[];
    holidays?: number[];
    drinkings?: number[];
    smokings?: number[];
    hobbies?: number[];
    languages?: number[];
    incomeVerified?: boolean;
    educationVerified?: boolean;
    unmarriedStatusVerified?: boolean;
};
export type GetUsersResponseBody = {
    users?: SearchUser[];
    hasNext?: boolean;
    lastSortUserId?: string;
    lastSortValue?: number;
};
export type GetUsersOrderByRecommendQuery = {
    seed: number;
    rankALastSortLoginPoint?: number;
    rankALastSortRandomScore?: number;
    rankAHasNotNext?: string;
    rankBLastSortLoginPoint?: number;
    rankBLastSortRandomScore?: number;
    rankBHasNotNext?: string;
    rankCLastSortLoginPoint?: number;
    rankCLastSortRandomScore?: number;
    rankCHasNotNext?: string;
    onlyCShipLastSortLoginPoint?: number;
    onlyCShipLastSortRandomScore?: number;
    onlyCShipHasNotNext?: string;
    isPaid?: boolean;
    isCShip?: boolean;
    residences?: number[];
    birthplaces?: number[];
    ageFrom?: number;
    ageTo?: number;
    heightsFrom?: number;
    heightsTo?: number;
    figures?: number[];
    bloodTypes?: number[];
    occupations?: number[];
    incomeFrom?: number;
    incomeTo?: number;
    educations?: number[];
    maritalStatuses?: number[];
    hasChildren?: number;
    houseworks?: number[];
    wantChildren?: number[];
    parentings?: number[];
    holidays?: number[];
    drinkings?: number[];
    smokings?: number[];
    hobbies?: number[];
    languages?: number[];
    incomeVerified?: boolean;
    educationVerified?: boolean;
    unmarriedStatusVerified?: boolean;
};
export type GetUsersOrderByRecommendResponseBody = {
    users?: SearchUser[];
    rankALastSortLoginPoint?: number;
    rankALastSortRandomScore?: number;
    rankAHasNext?: boolean;
    rankBLastSortLoginPoint?: number;
    rankBLastSortRandomScore?: number;
    rankBHasNext?: boolean;
    rankCLastSortLoginPoint?: number;
    rankCLastSortRandomScore?: number;
    rankCHasNext?: boolean;
    onlyCShipLastSortLoginPoint?: number;
    onlyCShipLastSortRandomScore?: number;
    onlyCShipHasNext?: boolean;
};
export type GetUsersCountQuery = {
    isPaid?: boolean;
    isCShip?: boolean;
    residences?: number[];
    birthplaces?: number[];
    ageFrom?: number;
    ageTo?: number;
    heightsFrom?: number;
    heightsTo?: number;
    figures?: number[];
    bloodTypes?: number[];
    occupations?: number[];
    incomeFrom?: number;
    incomeTo?: number;
    educations?: number[];
    maritalStatuses?: number[];
    hasChildren?: number;
    houseworks?: number[];
    wantChildren?: number[];
    parentings?: number[];
    holidays?: number[];
    drinkings?: number[];
    smokings?: number[];
    hobbies?: number[];
    languages?: number[];
    incomeVerified?: boolean;
    educationVerified?: boolean;
    unmarriedStatusVerified?: boolean;
};
export type GetUsersCountResponseBody = {
    total?: number;
    paidTotal?: number;
    cShipTotal?: number;
    noPaidTotal?: number;
    noCShipTotal?: number;
};
export type PostUsersBlockRequestBody = {
    targetUserId: string;
};
export type PostUsersBlockResponseBody = {
    success: boolean;
};
export type ReportType = typeof ReportType[keyof typeof ReportType];
export type PostUsersReportRequestBody = {
    targetUserId: string;
    type: ReportType;
    detail: string;
};
export type PostUsersReportResponseBody = {
    success: boolean;
};
export type GetUserByUserIdResponseBody = SearchUser;
export type GetMyLikesQuery = {
    page?: number;
    limit?: number;
};
export type MyLikeByDay = {
    day: string;
    records: {
        user: SearchUser | null;
        likeTime: string;
    }[];
};
export type GetMyLikesResponseBody = MyLikeByDay[];
export type GetMyLikersQuery = {
    offset?: number;
    sortType?: number;
    residences?: number[];
    birthplaces?: number[];
    ageFrom?: number;
    ageTo?: number;
    heightsFrom?: number;
    heightsTo?: number;
    figures?: number[];
    bloodTypes?: number[];
    occupations?: number[];
    incomeFrom?: number;
    incomeTo?: number;
    educations?: number[];
    maritalStatuses?: number[];
    hasChildren?: number;
    houseworks?: number[];
    wantChildren?: number[];
    parentings?: number[];
    holidays?: number[];
    drinkings?: number[];
    smokings?: number[];
    hobbies?: number[];
    languages?: number[];
    incomeVerified?: boolean;
    educationVerified?: boolean;
    unmarriedStatusVerified?: boolean;
    listGetTime?: string | Date;
};
export type GetMyLikersResponseBody = {
    users?: SearchUser[];
    hasNext?: boolean;
    offset?: number;
    listGetTime?: string | Date;
};
export type GetMySkipUsersQuery = {
    offset?: number;
};
export type GetMySkipUsersResponseBody = {
    users?: SearchUser[];
    hasNext?: boolean;
    offset?: number;
};
export type GetMyLikersCountQuery = {
    residences?: number[];
    birthplaces?: number[];
    ageFrom?: number;
    ageTo?: number;
    heightsFrom?: number;
    heightsTo?: number;
    figures?: number[];
    bloodTypes?: number[];
    occupations?: number[];
    incomeFrom?: number;
    incomeTo?: number;
    educations?: number[];
    maritalStatuses?: number[];
    hasChildren?: number;
    houseworks?: number[];
    wantChildren?: number[];
    parentings?: number[];
    holidays?: number[];
    drinkings?: number[];
    smokings?: number[];
    hobbies?: number[];
    languages?: number[];
    incomeVerified?: boolean;
    educationVerified?: boolean;
    unmarriedStatusVerified?: boolean;
};
export type GetMyLikersCountResponseBody = {
    total?: number;
};
export type SkipMyLikerRequestBody = {
    likerUserId: string;
};
export type SkipMyLikerResponseBody = {
    success: boolean;
};
export type SkipMyLikersQuery = {
    residences?: number[];
    birthplaces?: number[];
    ageFrom?: number;
    ageTo?: number;
    heightsFrom?: number;
    heightsTo?: number;
    figures?: number[];
    bloodTypes?: number[];
    occupations?: number[];
    incomeFrom?: number;
    incomeTo?: number;
    educations?: number[];
    maritalStatuses?: number[];
    hasChildren?: number;
    houseworks?: number[];
    wantChildren?: number[];
    parentings?: number[];
    holidays?: number[];
    drinkings?: number[];
    smokings?: number[];
    hobbies?: number[];
    languages?: number[];
    incomeVerified?: boolean;
    educationVerified?: boolean;
    unmarriedStatusVerified?: boolean;
    listGetTime?: string | Date;
};
export type SkipMyLikersResponseBody = {
    skippedLikerIds?: string[];
};
export type LikeStock = {
    userId: string;
    monthlyLike: number;
    likeGrantDate?: string | Date;
    activeBoostDays: number | null;
};
export type GetMyLikeStockResponseBody = LikeStock;
export type PostLikeRequestBody = {
    targetUserId: string;
    isReturnLike?: boolean;
};
export type PostLikeResponseBody = {
    monthlyLike?: number;
};
export type GetMyChatsQuery = {
    page?: number;
};
export type MyChat = {
    chatId: number;
    userId: string;
    mainPhoto: UserPublicPhoto;
    nickname: string;
    latestMessage?: string;
    latestMessageDate?: string | Date;
    unReadCnt?: number;
    isPaid: boolean;
    deleted: boolean;
};
export type GetMyChatsResponseBody = {
    chats?: MyChat[];
    hasNext?: boolean;
};
export type GetMyClosedChatsQuery = {
    page?: number;
};
export type MyClosedChat = {
    mainPhoto: UserPublicPhoto;
    nickname: string;
    userId: string;
};
export type GetMyClosedChatsResponseBody = {
    chats?: MyClosedChat[];
    hasNext?: boolean;
};
export type GetChatMessagesQuery = {
    previousOldestMessageId?: number;
};
export type ChatMessage = {
    messageId: number;
    messageDate: string;
    type: number;
    senderUser: string | null;
    message: string;
    disabled: boolean;
    data: {
        message: string;
        expand: {
            lead: {
                icon: string;
                label: string;
            };
            message: string;
        };
    } | null;
};
export type GetChatMessagesResponseBody = {
    messages?: ChatMessage[];
    hasNext?: boolean;
};
export type PostChatMessagesRequestBody = {
    message: string;
};
export type PostChatMessagesResponseBody = ChatMessage;
export type ChatCloseReason = typeof ChatCloseReason[keyof typeof ChatCloseReason];
export type CloseChatRoomRequestBody = {
    chatId: number;
    closeReasons: ChatCloseReason[];
    closeReasonDetail?: string | null;
};
export type CloseChatRoomResponseBody = {
    success: boolean;
};
export type PutChatMessagesReadRequestBody = {
    messageId: number;
};
export type PutChatMessagesReadResponseBody = {
    success: boolean;
};
export type GetUnreadChatsResponseBody = number[];
export type ConciergeChat = {
    conciergeChatId: number;
    status: number;
    photo: UserPublicPhoto;
    displayName: string;
    latestMessage: string | null;
    latestMessageDate: (string | Date) | null;
    unReadCnt: number;
    isPaid: boolean;
};
export type GetConciergeChatResponseBody = ConciergeChat;
export type GetConciergeChatMessagesQuery = {
    previousOldestMessageId?: number;
};
export type ConciergeProfile = {
    conciergeProfileId: number;
    displayName: string;
    photo: UserPublicPhoto;
};
export type ConciergeChatIntroEnum = typeof ConciergeChatIntroEnum[keyof typeof ConciergeChatIntroEnum];
export type ConciergeChatIntroductionUser = {
    type: ConciergeChatIntroEnum;
    userId: string;
};
export type ConciergeChatMessage = {
    conciergeMessageId: number;
    type: number | null;
    message: string;
    messageDate: string | Date;
    concierge: ConciergeProfile | null;
    data: (ConciergeChatIntroductionUser | ConciergeChatImage) | null;
};
export type GetConciergeChatMessagesResponseBody = ConciergeChatMessage[];
export type PostConciergeChatMessagesRequestBody = {
    message: string;
};
export type PostConciergeChatMessagesResponseBody = ConciergeChatMessage;
export type PutConciergeChatMessagesReadRequestBody = {
    conciergeMessageId: number;
};
export type PutConciergeChatMessagesReadResponseBody = {
    success: boolean;
};
export type ConciergeSchedule = {
    isNonWorkingDay: boolean;
};
export type GetConciergeScheduleResponseBody = ConciergeSchedule;
export type PostImageFilenameInConciergeChatRequestBody = {
    filename: string;
};
export type PostImageFilenameInConciergeChatResponseBody = ConciergeChatMessage;
export type GetIsApplyingWithdrawalResponseBody = {
    applyingWithdrawal: boolean;
};
export type WithdrawalRequestReason = typeof WithdrawalRequestReason[keyof typeof WithdrawalRequestReason];
export type RequestWithdrawalRequestBody = {
    reasons: WithdrawalRequestReason[];
    opinion?: string;
};
export type RequestWithdrawalResponseBody = {
    success: boolean;
};
export type PostSingleCertAgentRequestBody = {
    isForeignNationality?: boolean;
    zip: string;
    pref: Prefecture;
    city: string;
    address: string;
    building?: string;
    principalFamilyName: string;
    principalGivenName: string;
    principalFamilyNameKana: string;
    principalGivenNameKana: string;
    relationship: string;
    permanentZip: string;
    permanentPref: Prefecture;
    permanentCity: string;
    permanentAddress: string;
    permanentBuilding?: string;
};
export type PostSingleCertAgentResponseBody = {
    success: boolean;
};
export type PutUserAddressRequestBody = UserAddressParams;
export type PutUserAddressResponseBody = {
    success: boolean;
};
export type UserAddress = {
    userId: string;
    verified: boolean;
    zip: string;
    pref: Prefecture;
    city: string;
    address: string;
    building: string | null;
    zipReview: string | null;
    prefReview: Prefecture | null;
    cityReview: string | null;
    addressReview: string | null;
    buildingReview: string | null;
    rejectReason: RejectReason[] | null;
    createdDate: string | Date;
    updatedDate: (string | Date) | null;
    hasDocumentInRevew: boolean;
};
export type GetUserAddressResponseBody = UserAddress | null;
export type MyFootprint = {
    user: SearchUser;
    footprintId: number;
    footprintTime: string;
    isSeen: boolean;
};
export type MyFootprintsByDay = {
    day: string;
    records: MyFootprint[];
};
export type GetMyFootprintResponseBody = MyFootprintsByDay[];
export type PutFootprintRequestBody = {
    targetUserId: string;
};
export type PutFootprintResponseBody = {
    success: boolean;
};
export type PutFootprintSeenRequestBody = {
    lastSeenFootprintId: number;
};
export type PutFootprintSeenResponseBody = {
    success: boolean;
};
export type PutPaymentCreditCardZeusRequestBody = {
    tokenKey: string;
};
export type PutPaymentCreditCardZeusResponseBody = {
    success: boolean;
};
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
export type PaymentPlanEnum = typeof PaymentPlanEnum[keyof typeof PaymentPlanEnum];
export type PaymentMethodEnum = typeof PaymentMethodEnum[keyof typeof PaymentMethodEnum];
export type PostPaymentZeusSubscribeRequestBody = {
    currentPaymentState: {
        paymentType: PaymentType;
        paymentPlanId: PaymentPlanEnum | null;
        paymentMethod: PaymentMethodEnum | null;
    };
    newPayment: {
        paymentPlanId: PaymentPlanEnum;
        campaignId: string | null;
        amount: number;
        firstAmount: number | null;
    };
};
export type PostPaymentZeusSubscribeResponseBody = {
    success: boolean;
};
export type PostPaymentErrorLogRequestBody = {
    errorType: string;
    status: string;
    code: string;
};
export type PostPaymentErrorLogResponseBody = {
    success: boolean;
};
export type PostTransferToCardRequestBody = {
    tokenKey: string;
};
export type PostTransferToCardResponseBody = {
    success: boolean;
};
export type PutCancelTransferToCardResponseBody = {
    success: boolean;
};
export type PostThreeDSecureEnrollRequestBody = {
    tokenKey: string;
    count?: string;
    cardholderName?: string;
    cardholderEmail?: string;
    cardholderMobilePhoneCountryCode?: string;
    cardholderMobilePhoneNumber?: string;
};
export type PostThreeDSecureEnrollResponseBody = {
    success: boolean;
    status?: string;
    sessionId?: string;
    md?: string;
    termUrl?: string;
    iframeUrl?: string;
    clientIp?: string;
    errorCode?: string;
    errorMessage?: string;
};
export type PostThreeDSecurePayRequestBody = {
    sessionId: string;
    transStatus: string;
    eci?: string;
    authenticationValue?: string;
};
export type PostThreeDSecurePayResponseBody = {
    success: boolean;
    orderId?: string;
    cardLastFour?: string;
    cardExpiresMonth?: string;
    cardExpiresYear?: string;
    sendid?: string;
    errorCode?: string;
    errorMessage?: string;
};
export type PostThreeDSecureQuickEnrollRequestBody = {
    sendid: string;
    tokenKey?: string;
    count?: string;
};
export type PostThreeDSecureQuickEnrollResponseBody = {
    success: boolean;
    status?: string;
    sessionId?: string;
    md?: string;
    termUrl?: string;
    iframeUrl?: string;
    clientIp?: string;
    errorCode?: string;
    errorMessage?: string;
};
export type PostThreeDSecureQuickPayRequestBody = {
    sessionId: string;
    sendid: string;
    transStatus: string;
    eci?: string;
    authenticationValue?: string;
};
export type PostThreeDSecureQuickPayResponseBody = {
    success: boolean;
    orderId?: string;
    cardLastFour?: string;
    cardExpiresMonth?: string;
    cardExpiresYear?: string;
    sendid?: string;
    errorCode?: string;
    errorMessage?: string;
};
export type SubscriptionEnum = typeof SubscriptionEnum[keyof typeof SubscriptionEnum];
export type PaymentPlanType = {
    id: PaymentPlanEnum;
    subscription: SubscriptionEnum;
    paymentMethod: PaymentMethodEnum;
    title: string;
    amount: number;
    message: {
        title: string;
        description: string;
    };
};
export type PaymentCampaign = {
    campaignId: string;
    title: string;
    description: string;
    detail: string;
    fromDate: string | Date;
    toDate: string | Date;
    firstAmount: number;
    amount: number;
};
export type CardPaymentPlan = {
    paymentPlanId: PaymentPlanEnum;
    title: string;
    amount: number;
    message: {
        title: string;
        description: string;
    };
    campaigns: PaymentCampaign[];
};
export type IosIapPaymentPlan = {
    paymentPlanId: PaymentPlanEnum;
    productIdWithoutPrefix: string;
    title: string;
    message: {
        title: string;
        description: string;
    };
    amount: number;
    campaigns: PaymentCampaign[];
};
export type CreditCardInfo = {
    cardNumberSuffix: string;
    cardExpiresYear: string;
    cardExpiresMonth: string;
};
export type PaymentStatusObj = {
    paymentType: number;
    currentPaymentPlan: PaymentPlanType | null;
    cardPaymentPlans: CardPaymentPlan[];
    iosIapPaymentPlans: IosIapPaymentPlan[];
    nextPaymentDate: (string | Date) | null;
    paidFinishDate: (string | Date) | null;
    creditCardInfo?: CreditCardInfo | null;
    primaryPaymentMethod?: string | null;
    cardPaymentTransitionApplicationDate?: (string | Date) | null;
};
export type GetPaymentStatusResponseBody = PaymentStatusObj;
export type RegisterPaymentAddressRequestBody = {
    zip: string;
    pref: Prefecture;
    city: string;
    address: string;
    building?: string | null;
};
export type RegisterPaymentAddressResponseBody = {
    success: boolean;
};
export type PutPaymentStopPaidMemberResponseBody = {
    success: boolean;
};
export type PutPaymentRestartPaidMemberResponseBody = {
    success: boolean;
};
export type SearchBanner = {
    banner: number;
    imageUrl: string;
};
export type GetSearchBannersResponseBody = SearchBanner[];
export type SmokingPartnerCondition = typeof SmokingPartnerCondition[keyof typeof SmokingPartnerCondition];
export type EmphasisPartnerCondition = typeof EmphasisPartnerCondition[keyof typeof EmphasisPartnerCondition];
export type PartnerCondition = {
    userId: string;
    prefArea: string[];
    ageFrom: number;
    ageTo: number;
    annualIncomeFrom: number;
    annualIncomeTo: number;
    heightFrom: number;
    heightTo: number;
    education: number[];
    marriage: string;
    child: string;
    smoke: SmokingPartnerCondition;
    emphasis: EmphasisPartnerCondition[] | null;
    createdDate: string | Date;
    updatedDate: string | Date;
};
export type GetMyPartnerConditionResponseBody = PartnerCondition | null;
export type PartnerConditionEdit = {
    prefArea?: string[];
    ageFrom?: number;
    ageTo?: number;
    annualIncomeFrom?: number;
    annualIncomeTo?: number;
    heightFrom?: number;
    heightTo?: number;
    education?: number[];
    marriage?: string;
    child?: string;
    smoke?: SmokingPartnerCondition;
    emphasis?: EmphasisPartnerCondition[];
};
export type PutMyPartnerConditionRequestBody = PartnerConditionEdit;
export type PutMyPartnerConditionResponseBody = PartnerCondition;
export type PromotionPlatformEnum = typeof PromotionPlatformEnum[keyof typeof PromotionPlatformEnum];
export type GetPromotionsQuery = {
    platform?: PromotionPlatformEnum;
};
export type PromotionModal = {
    title: string | null;
    body: {
        type: string;
        data: string;
    }[];
    button: {
        text: string;
        type: string;
        dataStr?: string;
    } | null;
};
export type Promotion = {
    promotionEventParam: string;
    target: {
        isSearchBanner: boolean;
        isMyPageBanner: boolean;
        isStartup: boolean;
        isMatchingModal: boolean;
    };
    banner: {
        search: string | null;
        myPage: string | null;
        matchingModal: string | null;
    };
    modal: PromotionModal[];
};
export type GetPromotionsResponseBody = Promotion[];
export type MarriageActivityMarriageTiming = typeof MarriageActivityMarriageTiming[keyof typeof MarriageActivityMarriageTiming];
export type MarriageActivityUsedMarriageServices = typeof MarriageActivityUsedMarriageServices[keyof typeof MarriageActivityUsedMarriageServices];
export type MarriageActivityRecentIssues = typeof MarriageActivityRecentIssues[keyof typeof MarriageActivityRecentIssues];
export type MarriageActivityDesiredServices = typeof MarriageActivityDesiredServices[keyof typeof MarriageActivityDesiredServices];
export type MarriageActivityStatus = {
    userId: string;
    marriageTiming: MarriageActivityMarriageTiming | null;
    usedMarriageServices: MarriageActivityUsedMarriageServices[];
    recentIssues: MarriageActivityRecentIssues[];
    desiredServices: MarriageActivityDesiredServices[];
    createdDate: string | Date;
    updatedDate: string | Date;
};
export type GetMyMarriageActivityStatusResponseBody = MarriageActivityStatus | null;
export type MarriageActivityEdit = {
    marriageTiming: MarriageActivityMarriageTiming;
    usedMarriageServices: MarriageActivityUsedMarriageServices[];
    recentIssues: MarriageActivityRecentIssues[];
    desiredServices: MarriageActivityDesiredServices[];
};
export type PutMyMarriageActivityStatusRequestBody = MarriageActivityEdit;
export type PutMyMarriageActivityStatusResponseBody = MarriageActivityStatus;
export const DocumentReviewType = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5
} as const;
export const ConciergeChatImageEnum = {
    image: "image"
} as const;
export const CounselingType = {
    FreeCounseling: "FreeCounseling",
    CounselingAfterPay: "CounselingAfterPay"
} as const;
export const RejectReason = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15,
    _16: 16,
    _17: 17,
    _18: 18,
    _19: 19,
    _20: 20,
    _21: 21,
    _22: 22,
    _23: 23,
    _24: 24,
    _25: 25,
    _26: 26,
    _27: 27,
    _28: 28,
    _29: 29,
    _30: 30,
    _31: 31,
    _32: 32,
    _33: 33,
    _34: 34,
    _35: 35,
    _36: 36,
    _37: 37,
    _38: 38,
    _39: 39,
    _40: 40,
    _41: 41,
    _42: 42,
    _43: 43,
    _44: 44,
    _45: 45,
    _46: 46,
    _47: 47,
    _48: 48,
    _49: 49,
    _50: 50,
    _51: 51,
    _52: 52,
    _53: 53,
    _54: 54,
    _55: 55,
    _56: 56,
    _57: 57,
    _58: 58,
    _59: 59,
    _60: 60,
    _61: 61,
    _62: 62,
    _63: 63,
    _64: 64,
    _65: 65,
    _66: 66,
    _67: 67,
    _68: 68,
    _69: 69,
    _70: 70,
    _71: 71
} as const;
export const Gender = {
    f: "f",
    m: "m"
} as const;
export const Prefecture = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15,
    _16: 16,
    _17: 17,
    _18: 18,
    _19: 19,
    _20: 20,
    _21: 21,
    _22: 22,
    _23: 23,
    _24: 24,
    _25: 25,
    _26: 26,
    _27: 27,
    _28: 28,
    _29: 29,
    _30: 30,
    _31: 31,
    _32: 32,
    _33: 33,
    _34: 34,
    _35: 35,
    _36: 36,
    _37: 37,
    _38: 38,
    _39: 39,
    _40: 40,
    _41: 41,
    _42: 42,
    _43: 43,
    _44: 44,
    _45: 45,
    _46: 46,
    _47: 47,
    _99: 99
} as const;
export const Height = {
    _130: 130,
    _131: 131,
    _132: 132,
    _133: 133,
    _134: 134,
    _135: 135,
    _136: 136,
    _137: 137,
    _138: 138,
    _139: 139,
    _140: 140,
    _141: 141,
    _142: 142,
    _143: 143,
    _144: 144,
    _145: 145,
    _146: 146,
    _147: 147,
    _148: 148,
    _149: 149,
    _150: 150,
    _151: 151,
    _152: 152,
    _153: 153,
    _154: 154,
    _155: 155,
    _156: 156,
    _157: 157,
    _158: 158,
    _159: 159,
    _160: 160,
    _161: 161,
    _162: 162,
    _163: 163,
    _164: 164,
    _165: 165,
    _166: 166,
    _167: 167,
    _168: 168,
    _169: 169,
    _170: 170,
    _171: 171,
    _172: 172,
    _173: 173,
    _174: 174,
    _175: 175,
    _176: 176,
    _177: 177,
    _178: 178,
    _179: 179,
    _180: 180,
    _181: 181,
    _182: 182,
    _183: 183,
    _184: 184,
    _185: 185,
    _186: 186,
    _187: 187,
    _188: 188,
    _189: 189,
    _190: 190,
    _191: 191,
    _192: 192,
    _193: 193,
    _194: 194,
    _195: 195,
    _196: 196,
    _197: 197,
    _198: 198,
    _199: 199,
    _200: 200
} as const;
export const Figure = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8
} as const;
export const MaritalStatus = {
    _1: 1,
    _2: 2,
    _3: 3
} as const;
export const Occupation = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15,
    _16: 16,
    _17: 17,
    _18: 18,
    _19: 19,
    _20: 20,
    _21: 21,
    _22: 22,
    _23: 23,
    _24: 24,
    _25: 25,
    _26: 26,
    _27: 27,
    _28: 28,
    _29: 29,
    _30: 30,
    _31: 31,
    _32: 32,
    _33: 33,
    _34: 34,
    _35: 35,
    _36: 36,
    _37: 37,
    _38: 38,
    _39: 39,
    _40: 40,
    _41: 41,
    _42: 42,
    _43: 43,
    _44: 44,
    _45: 45,
    _46: 46,
    _47: 47,
    _48: 48
} as const;
export const WantChildren = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5
} as const;
export const HasChildren = {
    _1: 1,
    _2: 2
} as const;
export const ChildLiveTogether = {
    _1: 1,
    _2: 2
} as const;
export const ChildCustody = {
    _1: 1,
    _2: 2
} as const;
export const ChildPaySupport = {
    _1: 1,
    _2: 2
} as const;
export const AnnualIncomeRange = {
    _1: 1,
    _50: 50,
    _100: 100,
    _150: 150,
    _200: 200,
    _250: 250,
    _300: 300,
    _350: 350,
    _400: 400,
    _450: 450,
    _500: 500,
    _550: 550,
    _600: 600,
    _650: 650,
    _700: 700,
    _750: 750,
    _800: 800,
    _850: 850,
    _900: 900,
    _950: 950,
    _1000: 1000,
    _1100: 1100,
    _1200: 1200,
    _1300: 1300,
    _1400: 1400,
    _1500: 1500,
    _1600: 1600,
    _1700: 1700,
    _1800: 1800,
    _1900: 1900,
    _2000: 2000,
    _2100: 2100,
    _2200: 2200,
    _2300: 2300,
    _2400: 2400,
    _2500: 2500,
    _2600: 2600,
    _2700: 2700,
    _2800: 2800,
    _2900: 2900,
    _3000: 3000
} as const;
export const EducationLevel = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7
} as const;
export const BloodType = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6
} as const;
export const FamilyRelationship = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15,
    _16: 16,
    _17: 17,
    _18: 18,
    _19: 19,
    _20: 20,
    _21: 21
} as const;
export const LiveWithParent = {
    _1: 1,
    _2: 2,
    _3: 3
} as const;
export const JobDivision = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7
} as const;
export const Drinking = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6
} as const;
export const Smoking = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5
} as const;
export const Hobby = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15,
    _16: 16,
    _17: 17,
    _18: 18,
    _19: 19,
    _20: 20,
    _21: 21,
    _22: 22,
    _23: 23,
    _24: 24,
    _25: 25,
    _26: 26,
    _27: 27,
    _28: 28,
    _29: 29,
    _30: 30,
    _31: 31,
    _32: 32,
    _33: 33,
    _34: 34,
    _35: 35,
    _36: 36,
    _37: 37,
    _38: 38,
    _39: 39,
    _40: 40,
    _41: 41,
    _42: 42,
    _43: 43,
    _44: 44,
    _45: 45,
    _46: 46,
    _47: 47,
    _48: 48,
    _49: 49,
    _50: 50,
    _51: 51,
    _52: 52,
    _53: 53,
    _54: 54,
    _55: 55,
    _56: 56,
    _57: 57,
    _58: 58,
    _59: 59,
    _60: 60,
    _61: 61,
    _62: 62,
    _63: 63,
    _64: 64,
    _65: 65,
    _66: 66,
    _67: 67,
    _68: 68,
    _69: 69,
    _70: 70,
    _71: 71,
    _72: 72,
    _73: 73,
    _74: 74,
    _75: 75,
    _76: 76,
    _77: 77,
    _78: 78,
    _79: 79,
    _80: 80,
    _81: 81,
    _82: 82,
    _83: 83,
    _84: 84,
    _85: 85,
    _86: 86,
    _87: 87,
    _88: 88,
    _89: 89,
    _90: 90,
    _91: 91,
    _92: 92,
    _93: 93,
    _94: 94,
    _95: 95,
    _96: 96,
    _97: 97,
    _98: 98,
    _99: 99,
    _100: 100,
    _101: 101,
    _102: 102,
    _103: 103,
    _104: 104,
    _105: 105,
    _106: 106,
    _107: 107,
    _108: 108,
    _109: 109,
    _110: 110,
    _111: 111,
    _112: 112,
    _113: 113,
    _114: 114,
    _115: 115,
    _116: 116,
    _117: 117,
    _118: 118,
    _119: 119,
    _120: 120,
    _121: 121,
    _122: 122,
    _123: 123,
    _124: 124,
    _125: 125,
    _126: 126,
    _127: 127,
    _128: 128,
    _129: 129,
    _130: 130,
    _131: 131,
    _132: 132,
    _133: 133,
    _134: 134,
    _135: 135,
    _136: 136,
    _137: 137,
    _138: 138,
    _139: 139,
    _140: 140,
    _141: 141,
    _142: 142,
    _143: 143,
    _144: 144,
    _145: 145,
    _146: 146,
    _147: 147,
    _148: 148,
    _149: 149,
    _150: 150,
    _151: 151,
    _152: 152,
    _153: 153,
    _154: 154,
    _155: 155,
    _156: 156,
    _157: 157,
    _158: 158,
    _159: 159,
    _160: 160,
    _161: 161,
    _162: 162,
    _163: 163,
    _164: 164,
    _165: 165,
    _166: 166,
    _167: 167,
    _168: 168,
    _169: 169,
    _170: 170,
    _171: 171,
    _172: 172,
    _173: 173,
    _174: 174,
    _175: 175,
    _176: 176,
    _177: 177,
    _178: 178,
    _179: 179,
    _180: 180,
    _181: 181,
    _182: 182,
    _183: 183,
    _184: 184,
    _185: 185,
    _186: 186,
    _187: 187,
    _188: 188,
    _189: 189,
    _190: 190,
    _191: 191,
    _192: 192,
    _193: 193,
    _194: 194,
    _195: 195,
    _196: 196,
    _197: 197,
    _198: 198,
    _199: 199,
    _200: 200,
    _201: 201,
    _202: 202,
    _203: 203,
    _204: 204,
    _205: 205,
    _206: 206,
    _207: 207,
    _208: 208,
    _209: 209,
    _210: 210,
    _211: 211,
    _212: 212,
    _213: 213,
    _214: 214,
    _215: 215,
    _216: 216,
    _217: 217,
    _218: 218,
    _219: 219,
    _220: 220,
    _221: 221,
    _222: 222,
    _223: 223,
    _224: 224,
    _225: 225,
    _226: 226,
    _227: 227,
    _228: 228,
    _229: 229,
    _230: 230,
    _231: 231,
    _232: 232,
    _233: 233,
    _234: 234,
    _235: 235,
    _236: 236,
    _237: 237,
    _238: 238,
    _239: 239,
    _240: 240,
    _241: 241,
    _242: 242,
    _243: 243,
    _244: 244,
    _245: 245,
    _246: 246,
    _247: 247,
    _248: 248,
    _249: 249,
    _250: 250,
    _251: 251,
    _252: 252,
    _253: 253,
    _254: 254,
    _255: 255,
    _256: 256,
    _257: 257,
    _258: 258,
    _259: 259,
    _260: 260,
    _261: 261,
    _262: 262,
    _263: 263,
    _264: 264,
    _265: 265,
    _266: 266,
    _267: 267,
    _268: 268,
    _269: 269,
    _270: 270,
    _271: 271,
    _272: 272,
    _273: 273,
    _274: 274,
    _275: 275,
    _276: 276,
    _277: 277,
    _278: 278,
    _279: 279,
    _280: 280,
    _281: 281,
    _282: 282,
    _283: 283,
    _284: 284,
    _285: 285,
    _286: 286,
    _287: 287,
    _288: 288,
    _289: 289,
    _290: 290,
    _291: 291,
    _292: 292,
    _293: 293,
    _294: 294,
    _295: 295,
    _296: 296,
    _297: 297,
    _298: 298,
    _299: 299,
    _300: 300,
    _301: 301,
    _302: 302,
    _303: 303,
    _304: 304,
    _305: 305,
    _306: 306,
    _307: 307,
    _308: 308,
    _309: 309,
    _310: 310,
    _311: 311,
    _312: 312
} as const;
export const MarriageTiming = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6
} as const;
export const HouseWork = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5
} as const;
export const Parenting = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5
} as const;
export const Holiday = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5
} as const;
export const Language = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15,
    _16: 16,
    _17: 17,
    _18: 18,
    _19: 19,
    _20: 20,
    _21: 21
} as const;
export const FaceType = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8
} as const;
export const EQ = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10
} as const;
export const ReportType = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10
} as const;
export const ChatCloseReason = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6
} as const;
export const ConciergeChatIntroEnum = {
    intro: "intro"
} as const;
export const WithdrawalRequestReason = {
    _1: 1,
    _2: 2,
    _3: 3,
    _4: 4,
    _5: 5,
    _6: 6,
    _7: 7,
    _8: 8,
    _9: 9,
    _10: 10,
    _11: 11,
    _12: 12,
    _13: 13,
    _14: 14,
    _15: 15
} as const;
export const PaymentType = {
    _1: 1,
    _2: 2
} as const;
export const PaymentPlanEnum = {
    STANDARD_1M_CARD_9800: "STANDARD_1M_CARD_9800",
    STANDARD_1M_IOS_IAP_12000: "STANDARD_1M_IOS_IAP_12000",
    LITE_1M_CARD_1000: "LITE_1M_CARD_1000",
    LITE_1M_IOS_IAP_1000: "LITE_1M_IOS_IAP_1000"
} as const;
export const PaymentMethodEnum = {
    ios_iap: "ios_iap",
    android_iap: "android_iap",
    credit_card: "credit_card"
} as const;
export const SubscriptionEnum = {
    STANDARD: "STANDARD",
    LITE: "LITE"
} as const;
export const SmokingPartnerCondition = {
    INDIFFERENT: "INDIFFERENT",
    NON_SMOKING: "NON_SMOKING",
    SMOKING: "SMOKING"
} as const;
export const EmphasisPartnerCondition = {
    SENSE_OF_VALUES: "SENSE_OF_VALUES",
    HOBBIES: "HOBBIES",
    APPEARANCE: "APPEARANCE",
    PERSONALITY: "PERSONALITY",
    BODY_SHAPE: "BODY_SHAPE",
    ECONOMIC: "ECONOMIC",
    EDUCATION: "EDUCATION",
    AGE: "AGE"
} as const;
export const PromotionPlatformEnum = {
    ios: "ios",
    android: "android"
} as const;
export const MarriageActivityMarriageTiming = {
    Within6M: "Within6M",
    Within1Y: "Within1Y",
    Within2To3Y: "Within2To3Y",
    MoreThan3Y: "MoreThan3Y"
} as const;
export const MarriageActivityUsedMarriageServices = {
    MARRIAGE_COUNSELING: "MARRIAGE_COUNSELING",
    MATCHING_APP: "MATCHING_APP",
    PARTY_EVENT: "PARTY_EVENT",
    FIRST_TIME: "FIRST_TIME"
} as const;
export const MarriageActivityRecentIssues = {
    NO_MATCH: "NO_MATCH",
    FEW_PEOPLE: "FEW_PEOPLE",
    LOW_CONFIDENCE: "LOW_CONFIDENCE",
    APPS_FAILED: "APPS_FAILED",
    POOR_TEXT: "POOR_TEXT",
    MATCH_UNCERTAINTY: "MATCH_UNCERTAINTY"
} as const;
export const MarriageActivityDesiredServices = {
    SERIOUS_ONLY: "SERIOUS_ONLY",
    DESIRED_ONLY: "DESIRED_ONLY",
    IN_PERSON: "IN_PERSON",
    EXTENSIVE_SUPPORT: "EXTENSIVE_SUPPORT",
    NEED_FEEDBACK: "NEED_FEEDBACK",
    ATTEND_PARTIES: "ATTEND_PARTIES",
    OPTIONAL_SERVICES: "OPTIONAL_SERVICES"
} as const;
export class GetSignedUrlConfidentialRequestBodyValidator {
    /**
     * isIdentify
     */
    @IsNotEmpty()
    @IsBoolean()
    isIdentify: boolean;
    /**
     * documentType
     */
    @IsOptional()
    @IsIn(Object.values(DocumentReviewType))
    documentType: DocumentReviewType;
}
export class GetS3SignedUrlInConciergeChatRequestBodyValidator {
    /**
     * width
     */
    @IsNotEmpty()
    width: number;
    /**
     * height
     */
    @IsNotEmpty()
    height: number;
}
export class GetDownloadS3SignedUrlInConciergeChatQueryValidator {
    /**
     * filename
     */
    @IsNotEmpty()
    filename: string;
}
export class GetMyNoticesQueryValidator {
    /**
     * page number of user notices data
     */
    @IsOptional()
    @IsInt()
    page: number;
}
export class PostCounselingReservationRequestBodyValidator {
    /**
     * counselingType
     */
    @IsOptional()
    @IsIn(Object.values(CounselingType))
    counselingType: CounselingType;
    /**
     * counselingMethod
     */
    @IsOptional()
    counselingMethod: string;
    /**
     * firstPreferredDate
     */
    @IsNotEmpty()
    firstPreferredDate: string;
    /**
     * firstPreferredTime
     */
    @IsOptional()
    firstPreferredTime: string;
    /**
     * secondPreferredDate
     */
    @IsOptional()
    secondPreferredDate: string;
    /**
     * secondPreferredTime
     */
    @IsOptional()
    secondPreferredTime: string;
    /**
     * thirdPreferredDate
     */
    @IsOptional()
    thirdPreferredDate: string;
    /**
     * thirdPreferredTime
     */
    @IsOptional()
    thirdPreferredTime: string;
}
export class PutMySettingsRequestBodyValidator {
    /**
     * reviewResultEmail
     */
    @IsNotEmpty()
    @IsBoolean()
    reviewResultEmail: boolean;
    /**
     * likeEmail
     */
    @IsNotEmpty()
    @IsBoolean()
    likeEmail: boolean;
    /**
     * matchingEmail
     */
    @IsNotEmpty()
    @IsBoolean()
    matchingEmail: boolean;
    /**
     * messageEmail
     */
    @IsNotEmpty()
    @IsBoolean()
    messageEmail: boolean;
    /**
     * noticeEmail
     */
    @IsNotEmpty()
    @IsBoolean()
    noticeEmail: boolean;
    /**
     * reviewResultPush
     */
    @IsNotEmpty()
    @IsBoolean()
    reviewResultPush: boolean;
    /**
     * likePush
     */
    @IsNotEmpty()
    @IsBoolean()
    likePush: boolean;
    /**
     * matchingPush
     */
    @IsNotEmpty()
    @IsBoolean()
    matchingPush: boolean;
    /**
     * messagePush
     */
    @IsNotEmpty()
    @IsBoolean()
    messagePush: boolean;
    /**
     * noticePush
     */
    @IsNotEmpty()
    @IsBoolean()
    noticePush: boolean;
    /**
     * mutePushStartHour
     */
    @IsOptional()
    @IsInt()
    @Min(0)
    @Max(23)
    mutePushStartHour: number;
    /**
     * mutePushEndHour
     */
    @IsOptional()
    @IsInt()
    @Min(0)
    @Max(23)
    mutePushEndHour: number;
}
export class PutMySettingsPushNotificationsRequestBodyValidator {
    /**
     * token
     */
    @IsNotEmpty()
    token: string;
}
export class PutMySettingsPhoneRequestBodyValidator {
    /**
     * phone
     */
    @IsNotEmpty()
    @Length(10, 16)
    @Matches(/^[+][0-9]+$|^[0-9]+$/)
    phone: string;
}
export class PutMyNoticeSeenRequestBodyValidator {
    /**
     * lastSeenNoticeId
     */
    @IsNotEmpty()
    @IsInt()
    lastSeenNoticeId: number;
}
export class PutIdentifyReviewRequestBodyValidator {
    /**
     * identifyCertificate
     */
    @IsOptional()
    identifyCertificate: string;
    /**
     * identifyCertificateBack
     */
    @IsOptional()
    identifyCertificateBack: string;
}
export class PostDocumentReviewRequestBodyValidator {
    /**
     * type
     */
    @IsNotEmpty()
    @IsIn(Object.values(DocumentReviewType))
    type: DocumentReviewType;
    /**
     * value
     */
    @IsOptional()
    value: number;
    /**
     * filename
     */
    @IsNotEmpty()
    filename: string;
    /**
     * filename2
     */
    @IsOptional()
    filename2: string;
    /**
     * filename3
     */
    @IsOptional()
    filename3: string;
}
export class VerifyReceiptRequestBodyValidator {
    /**
     * レシートのBase64データ
     */
    @IsNotEmpty()
    receipt: string;
    /**
     * OS名
     */
    @IsNotEmpty()
    @Matches(/ios|android/)
    platform: string;
}
export class PostMyUserRequestBodyValidator {
    /**
     * nickname
     */
    @IsNotEmpty()
    @Length(1, 24)
    nickname: string;
    /**
     * phone
     */
    @IsNotEmpty()
    @MaxLength(15)
    phone: string;
    /**
     * gender
     */
    @IsNotEmpty()
    @IsIn(Object.values(Gender))
    gender: Gender;
    /**
     * birthday
     */
    @IsNotEmpty()
    birthday: string;
    /**
     * pref
     */
    @IsNotEmpty()
    @ValidateIf(o => o.pref !== null)
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
}
export class PatchMyUserRequestBodyValidator {
    /**
     * mainPhoto
     */
    @IsNotEmpty()
    @ValidateIf(o => o.mainPhoto !== null)
    mainPhoto: string;
    /**
     * subPhotos
     */
    @IsNotEmpty()
    @IsArray()
    subPhotos: string[];
    /**
     * nickname
     */
    @IsNotEmpty()
    @Length(1, 24)
    nickname: string;
    /**
     * weight
     */
    @IsOptional()
    weight: number;
    /**
     * address
     */
    @IsOptional()
    @MaxLength(48)
    address: string;
    /**
     * phone
     */
    @IsNotEmpty()
    @MaxLength(15)
    phone: string;
    /**
     * zip
     */
    @IsOptional()
    @MaxLength(7)
    zip: string;
}
export class PostPaidRegisterUserRequestBodyValidator {
    /**
     * nickname
     */
    @IsNotEmpty()
    nickname: string;
    /**
     * familyName
     */
    @IsNotEmpty()
    @MaxLength(24)
    familyName: string;
    /**
     * givenName
     */
    @IsNotEmpty()
    @MaxLength(24)
    givenName: string;
    /**
     * familyNameKana
     */
    @IsNotEmpty()
    @MaxLength(24)
    familyNameKana: string;
    /**
     * givenNameKana
     */
    @IsNotEmpty()
    @MaxLength(24)
    givenNameKana: string;
    /**
     * birthday
     */
    @IsNotEmpty()
    @Matches(
        /^(19[0-9]{2}|20[0-9]{2})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
    )
    birthday: string;
    /**
     * gender
     */
    @IsNotEmpty()
    @IsIn(Object.values(Gender))
    gender: Gender;
    /**
     * phone
     */
    @IsNotEmpty()
    @Length(10, 16)
    @Matches(/^[+][0-9]+$|^[0-9]+$/)
    phone: string;
    /**
     * zip
     */
    @IsNotEmpty()
    @Length(7, 8)
    @Matches(/^[0-9]+$/)
    zip: string;
    /**
     * pref
     */
    @IsNotEmpty()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * city
     */
    @IsNotEmpty()
    city: string;
    /**
     * address
     */
    @IsNotEmpty()
    address: string;
    /**
     * building
     */
    @IsOptional()
    building: string;
}
export class UserCanEditProfileValidator {
    /**
     * pref
     */
    @IsOptional()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * bornPref
     */
    @IsOptional()
    @IsIn(Object.values(Prefecture))
    bornPref: Prefecture;
    /**
     * height
     */
    @IsOptional()
    @IsIn(Object.values(Height))
    height: Height;
    /**
     * figure
     */
    @IsOptional()
    @IsIn(Object.values(Figure))
    figure: Figure;
    /**
     * marriage
     */
    @IsOptional()
    @IsIn(Object.values(MaritalStatus))
    marriage: MaritalStatus;
    /**
     * occupation
     */
    @IsOptional()
    @IsIn(Object.values(Occupation))
    occupation: Occupation;
    /**
     * wantChild
     */
    @IsOptional()
    @IsIn(Object.values(WantChildren))
    wantChild: WantChildren;
    /**
     * hasChild
     */
    @IsOptional()
    @IsIn(Object.values(HasChildren))
    hasChild: HasChildren;
    /**
     * childLiveTogether
     */
    @IsOptional()
    @IsIn(Object.values(ChildLiveTogether))
    childLiveTogether: ChildLiveTogether;
    /**
     * childCustody
     */
    @IsOptional()
    @IsIn(Object.values(ChildCustody))
    childCustody: ChildCustody;
    /**
     * childPaySupport
     */
    @IsOptional()
    @IsIn(Object.values(ChildPaySupport))
    childPaySupport: ChildPaySupport;
    /**
     * officeName
     */
    @IsOptional()
    @MaxLength(48)
    officeName: string;
    /**
     * jobName
     */
    @IsOptional()
    @MaxLength(64)
    jobName: string;
    /**
     * annualIncome
     */
    @IsOptional()
    @IsIn(Object.values(AnnualIncomeRange))
    annualIncome: AnnualIncomeRange;
    /**
     * education
     */
    @IsOptional()
    @IsIn(Object.values(EducationLevel))
    education: EducationLevel;
    /**
     * schoolName
     */
    @IsOptional()
    @MaxLength(48)
    schoolName: string;
    /**
     * selfPr
     */
    @IsOptional()
    @MaxLength(460)
    selfPr: string;
    /**
     * bloodType
     */
    @IsOptional()
    @IsIn(Object.values(BloodType))
    bloodType: BloodType;
    /**
     * familyRelationship
     */
    @IsOptional()
    @IsIn(Object.values(FamilyRelationship))
    familyRelationship: FamilyRelationship;
    /**
     * liveWithParent
     */
    @IsOptional()
    @IsIn(Object.values(LiveWithParent))
    liveWithParent: LiveWithParent;
    /**
     * jobDivision
     */
    @IsOptional()
    @IsIn(Object.values(JobDivision))
    jobDivision: JobDivision;
    /**
     * drink
     */
    @IsOptional()
    @IsIn(Object.values(Drinking))
    drink: Drinking;
    /**
     * smoke
     */
    @IsOptional()
    @IsIn(Object.values(Smoking))
    smoke: Smoking;
    /**
     * hobby
     */
    @IsOptional()
    @IsArray()
    @IsIn(Object.values(Hobby), { each: true })
    hobby: Hobby[];
    /**
     * hobbyObsession
     */
    @IsOptional()
    @MaxLength(60)
    hobbyObsession: string;
    /**
     * wantToDo
     */
    @IsOptional()
    @MaxLength(30)
    wantToDo: string;
    /**
     * likeThing
     */
    @IsOptional()
    @MaxLength(60)
    likeThing: string;
    /**
     * dislikeThing
     */
    @IsOptional()
    @MaxLength(60)
    dislikeThing: string;
    /**
     * idealMarriage
     */
    @IsOptional()
    @MaxLength(60)
    idealMarriage: string;
    /**
     * comment
     */
    @IsOptional()
    @MaxLength(30)
    comment: string;
    /**
     * marriageTiming
     */
    @IsOptional()
    @IsIn(Object.values(MarriageTiming))
    marriageTiming: MarriageTiming;
    /**
     * housework
     */
    @IsOptional()
    @IsIn(Object.values(HouseWork))
    housework: HouseWork;
    /**
     * parenting
     */
    @IsOptional()
    @IsIn(Object.values(Parenting))
    parenting: Parenting;
    /**
     * holiday
     */
    @IsOptional()
    @IsIn(Object.values(Holiday))
    holiday: Holiday;
    /**
     * language
     */
    @IsOptional()
    @IsArray()
    @IsIn(Object.values(Language), { each: true })
    language: Language[];
    /**
     * faceType
     */
    @IsOptional()
    @IsIn(Object.values(FaceType))
    faceType: FaceType;
    /**
     * faceTypeTarget
     */
    @IsOptional()
    @IsIn(Object.values(FaceType))
    faceTypeTarget: FaceType;
    /**
     * eqType
     */
    @IsOptional()
    @IsIn(Object.values(EQ))
    eqType: EQ;
    /**
     * eqTypeTarget
     */
    @IsOptional()
    @IsIn(Object.values(EQ))
    eqTypeTarget: EQ;
}
export class UserAddressParamsValidator {
    /**
     * zip
     */
    @IsNotEmpty()
    @Length(7, 7)
    zip: string;
    /**
     * pref
     */
    @IsNotEmpty()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * city
     */
    @IsNotEmpty()
    @MaxLength(48)
    city: string;
    /**
     * address
     */
    @IsNotEmpty()
    @MaxLength(25)
    address: string;
    /**
     * building
     */
    @IsOptional()
    @MaxLength(25)
    building: string;
}
export class PutMyUserBasicInfoRequestBodyValidator {
    /**
     * mainPhoto
     */
    @IsOptional()
    mainPhoto: string;
    /**
     * familyName
     */
    @IsOptional()
    familyName: string;
    /**
     * givenName
     */
    @IsOptional()
    givenName: string;
    /**
     * familyNameKana
     */
    @IsOptional()
    familyNameKana: string;
    /**
     * givenNameKana
     */
    @IsOptional()
    givenNameKana: string;
    /**
     * nickname
     */
    @IsOptional()
    nickname: string;
    /**
     * birthday
     */
    @IsOptional()
    birthday: string;
    /**
     * userProfile
     */
    @IsOptional()
    @ValidateNested()
    @Type(() => UserCanEditProfileValidator)
    userProfile: UserCanEditProfile;
    /**
     * userAddress
     */
    @IsOptional()
    @ValidateNested()
    @Type(() => UserAddressParamsValidator)
    userAddress: UserAddressParams;
}
export class PutPhotoForCShipRequestBodyValidator {
    /**
     * mainPhoto
     */
    @IsNotEmpty()
    mainPhoto: string;
}
export class PutMyUserProfileRequestBodyValidator {
    /**
     * pref
     */
    @IsOptional()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * bornPref
     */
    @IsOptional()
    @IsIn(Object.values(Prefecture))
    bornPref: Prefecture;
    /**
     * height
     */
    @IsOptional()
    @IsIn(Object.values(Height))
    height: Height;
    /**
     * figure
     */
    @IsOptional()
    @IsIn(Object.values(Figure))
    figure: Figure;
    /**
     * marriage
     */
    @IsOptional()
    @IsIn(Object.values(MaritalStatus))
    marriage: MaritalStatus;
    /**
     * occupation
     */
    @IsOptional()
    @IsIn(Object.values(Occupation))
    occupation: Occupation;
    /**
     * wantChild
     */
    @IsOptional()
    @IsIn(Object.values(WantChildren))
    wantChild: WantChildren;
    /**
     * hasChild
     */
    @IsOptional()
    @IsIn(Object.values(HasChildren))
    hasChild: HasChildren;
    /**
     * childLiveTogether
     */
    @IsOptional()
    @IsIn(Object.values(ChildLiveTogether))
    childLiveTogether: ChildLiveTogether;
    /**
     * childCustody
     */
    @IsOptional()
    @IsIn(Object.values(ChildCustody))
    childCustody: ChildCustody;
    /**
     * childPaySupport
     */
    @IsOptional()
    @IsIn(Object.values(ChildPaySupport))
    childPaySupport: ChildPaySupport;
    /**
     * officeName
     */
    @IsOptional()
    @MaxLength(48)
    officeName: string;
    /**
     * jobName
     */
    @IsOptional()
    @MaxLength(64)
    jobName: string;
    /**
     * annualIncome
     */
    @IsOptional()
    @IsIn(Object.values(AnnualIncomeRange))
    annualIncome: AnnualIncomeRange;
    /**
     * education
     */
    @IsOptional()
    @IsIn(Object.values(EducationLevel))
    education: EducationLevel;
    /**
     * schoolName
     */
    @IsOptional()
    @MaxLength(48)
    schoolName: string;
    /**
     * selfPr
     */
    @IsOptional()
    @MaxLength(460)
    selfPr: string;
    /**
     * bloodType
     */
    @IsOptional()
    @IsIn(Object.values(BloodType))
    bloodType: BloodType;
    /**
     * familyRelationship
     */
    @IsOptional()
    @IsIn(Object.values(FamilyRelationship))
    familyRelationship: FamilyRelationship;
    /**
     * liveWithParent
     */
    @IsOptional()
    @IsIn(Object.values(LiveWithParent))
    liveWithParent: LiveWithParent;
    /**
     * jobDivision
     */
    @IsOptional()
    @IsIn(Object.values(JobDivision))
    jobDivision: JobDivision;
    /**
     * drink
     */
    @IsOptional()
    @IsIn(Object.values(Drinking))
    drink: Drinking;
    /**
     * smoke
     */
    @IsOptional()
    @IsIn(Object.values(Smoking))
    smoke: Smoking;
    /**
     * hobby
     */
    @IsOptional()
    @IsArray()
    @IsIn(Object.values(Hobby), { each: true })
    hobby: Hobby[];
    /**
     * hobbyObsession
     */
    @IsOptional()
    @MaxLength(60)
    hobbyObsession: string;
    /**
     * wantToDo
     */
    @IsOptional()
    @MaxLength(30)
    wantToDo: string;
    /**
     * likeThing
     */
    @IsOptional()
    @MaxLength(60)
    likeThing: string;
    /**
     * dislikeThing
     */
    @IsOptional()
    @MaxLength(60)
    dislikeThing: string;
    /**
     * idealMarriage
     */
    @IsOptional()
    @MaxLength(60)
    idealMarriage: string;
    /**
     * comment
     */
    @IsOptional()
    @MaxLength(30)
    comment: string;
    /**
     * marriageTiming
     */
    @IsOptional()
    @IsIn(Object.values(MarriageTiming))
    marriageTiming: MarriageTiming;
    /**
     * housework
     */
    @IsOptional()
    @IsIn(Object.values(HouseWork))
    housework: HouseWork;
    /**
     * parenting
     */
    @IsOptional()
    @IsIn(Object.values(Parenting))
    parenting: Parenting;
    /**
     * holiday
     */
    @IsOptional()
    @IsIn(Object.values(Holiday))
    holiday: Holiday;
    /**
     * language
     */
    @IsOptional()
    @IsArray()
    @IsIn(Object.values(Language), { each: true })
    language: Language[];
    /**
     * faceType
     */
    @IsOptional()
    @IsIn(Object.values(FaceType))
    faceType: FaceType;
    /**
     * faceTypeTarget
     */
    @IsOptional()
    @IsIn(Object.values(FaceType))
    faceTypeTarget: FaceType;
    /**
     * eqType
     */
    @IsOptional()
    @IsIn(Object.values(EQ))
    eqType: EQ;
    /**
     * eqTypeTarget
     */
    @IsOptional()
    @IsIn(Object.values(EQ))
    eqTypeTarget: EQ;
}
export class PostAvCongenialityAnswerRequestBodyValidator {
    /**
     * answer
     */
    @IsNotEmpty()
    @IsArray()
    answer: number[];
}
export class PostVfCongenialityAnswerRequestBodyValidator {
    /**
     * answer
     */
    @IsNotEmpty()
    @IsArray()
    answer: number[];
}
export class PostAuthLoginRequestBodyValidator {
    /**
     * email
     */
    @IsNotEmpty()
    @MaxLength(128)
    @IsEmail()
    email: string;
    /**
     * isSignUp
     */
    @IsNotEmpty()
    @IsBoolean()
    isSignUp: boolean;
}
export class PostAuthCodeRequestBodyValidator {
    /**
     * email
     */
    @IsNotEmpty()
    @IsEmail()
    email: string;
    /**
     * code
     */
    @IsNotEmpty()
    code: string;
}
export class PutNewEmailLoginRequestBodyValidator {
    /**
     * newEmail
     */
    @IsNotEmpty()
    @MaxLength(128)
    @IsEmail()
    newEmail: string;
}
export class PutNewEmailCodeRequestBodyValidator {
    /**
     * newEmail
     */
    @IsNotEmpty()
    @IsEmail()
    newEmail: string;
    /**
     * code
     */
    @IsNotEmpty()
    code: string;
}
export class GetUsersQueryValidator {
    /**
     * previous last sort userId of pagination
     */
    @IsOptional()
    lastSortUserId: string;
    /**
     * ページングで前回取得した最終レコードのソート値
     */
    @IsOptional()
    lastSortValue: number;
    /**
     * 課金中
     */
    @IsOptional()
    @IsBoolean()
    isPaid: boolean;
    /**
     * c-ship中
     */
    @IsOptional()
    @IsBoolean()
    isCShip: boolean;
    /**
     * Users Sort Type
     */
    @IsOptional()
    @IsInt()
    sortType: number;
    /**
     * 居住地
     */
    @IsOptional()
    @IsArray()
    residences: number[];
    /**
     * 出身地
     */
    @IsOptional()
    @IsArray()
    birthplaces: number[];
    /**
     * 年齢下限
     */
    @IsOptional()
    @IsInt()
    ageFrom: number;
    /**
     * 年齢上限
     */
    @IsOptional()
    @IsInt()
    ageTo: number;
    /**
     * 身長下限
     */
    @IsOptional()
    @IsInt()
    heightsFrom: number;
    /**
     * 身長上限
     */
    @IsOptional()
    @IsInt()
    heightsTo: number;
    /**
     * 体型
     */
    @IsOptional()
    @IsArray()
    figures: number[];
    /**
     * 血液型
     */
    @IsOptional()
    @IsArray()
    bloodTypes: number[];
    /**
     * 職種
     */
    @IsOptional()
    @IsArray()
    occupations: number[];
    /**
     * 年収下限
     */
    @IsOptional()
    @IsInt()
    incomeFrom: number;
    /**
     * 年収上限
     */
    @IsOptional()
    @IsInt()
    incomeTo: number;
    /**
     * 学歴
     */
    @IsOptional()
    @IsArray()
    educations: number[];
    /**
     * 結婚歴
     */
    @IsOptional()
    @IsArray()
    maritalStatuses: number[];
    /**
     * 子供の有無
     */
    @IsOptional()
    hasChildren: number;
    /**
     * 家事
     */
    @IsOptional()
    @IsArray()
    houseworks: number[];
    /**
     * 子供がほしいか
     */
    @IsOptional()
    @IsArray()
    wantChildren: number[];
    /**
     * 育児
     */
    @IsOptional()
    @IsArray()
    parentings: number[];
    /**
     * 休日
     */
    @IsOptional()
    @IsArray()
    holidays: number[];
    /**
     * 飲酒の習慣
     */
    @IsOptional()
    @IsArray()
    drinkings: number[];
    /**
     * 喫煙の習慣
     */
    @IsOptional()
    @IsArray()
    smokings: number[];
    /**
     * 趣味
     */
    @IsOptional()
    @IsArray()
    hobbies: number[];
    /**
     * 話せる言語
     */
    @IsOptional()
    @IsArray()
    languages: number[];
    /**
     * 年収証明書
     */
    @IsOptional()
    @IsBoolean()
    incomeVerified: boolean;
    /**
     * 学歴証明書
     */
    @IsOptional()
    @IsBoolean()
    educationVerified: boolean;
    /**
     * 独身証明書
     */
    @IsOptional()
    @IsBoolean()
    unmarriedStatusVerified: boolean;
}
export class GetUsersOrderByRecommendQueryValidator {
    /**
     * ランダムソートのページングで一貫性を保つ為の値
     */
    @IsNotEmpty()
    seed: number;
    /**
     * ページングで前回取得したrankAの最終レコードのログインポイント
     */
    @IsOptional()
    rankALastSortLoginPoint: number;
    /**
     * ページングで前回取得したrankAの最終レコードのランダムスコア
     */
    @IsOptional()
    rankALastSortRandomScore: number;
    /**
     * rankAユーザーのレコードがもうない
     */
    @IsOptional()
    rankAHasNotNext: string;
    /**
     * ページングで前回取得したrankBの最終レコードのログインポイント
     */
    @IsOptional()
    rankBLastSortLoginPoint: number;
    /**
     * ページングで前回取得したrankBの最終レコードのランダムスコア
     */
    @IsOptional()
    rankBLastSortRandomScore: number;
    /**
     * rankBユーザーのレコードがもうない
     */
    @IsOptional()
    rankBHasNotNext: string;
    /**
     * ページングで前回取得したrankCの最終レコードのログインポイント
     */
    @IsOptional()
    rankCLastSortLoginPoint: number;
    /**
     * ページングで前回取得したrankCの最終レコードのランダムスコア
     */
    @IsOptional()
    rankCLastSortRandomScore: number;
    /**
     * rankCユーザーのレコードがもうない
     */
    @IsOptional()
    rankCHasNotNext: string;
    /**
     * ページングで前回取得したrankCの最終レコードのログインポイント
     */
    @IsOptional()
    onlyCShipLastSortLoginPoint: number;
    /**
     * ページングで前回取得したCShipのみの最終レコードのランダムスコア
     */
    @IsOptional()
    onlyCShipLastSortRandomScore: number;
    /**
     * onlyCShipユーザーのレコードがもうない
     */
    @IsOptional()
    onlyCShipHasNotNext: string;
    /**
     * 課金中
     */
    @IsOptional()
    @IsBoolean()
    isPaid: boolean;
    /**
     * c-ship中
     */
    @IsOptional()
    @IsBoolean()
    isCShip: boolean;
    /**
     * 居住地
     */
    @IsOptional()
    @IsArray()
    residences: number[];
    /**
     * 出身地
     */
    @IsOptional()
    @IsArray()
    birthplaces: number[];
    /**
     * 年齢下限
     */
    @IsOptional()
    @IsInt()
    ageFrom: number;
    /**
     * 年齢上限
     */
    @IsOptional()
    @IsInt()
    ageTo: number;
    /**
     * 身長下限
     */
    @IsOptional()
    @IsInt()
    heightsFrom: number;
    /**
     * 身長上限
     */
    @IsOptional()
    @IsInt()
    heightsTo: number;
    /**
     * 体型
     */
    @IsOptional()
    @IsArray()
    figures: number[];
    /**
     * 血液型
     */
    @IsOptional()
    @IsArray()
    bloodTypes: number[];
    /**
     * 職種
     */
    @IsOptional()
    @IsArray()
    occupations: number[];
    /**
     * 年収下限
     */
    @IsOptional()
    @IsInt()
    incomeFrom: number;
    /**
     * 年収上限
     */
    @IsOptional()
    @IsInt()
    incomeTo: number;
    /**
     * 学歴
     */
    @IsOptional()
    @IsArray()
    educations: number[];
    /**
     * 結婚歴
     */
    @IsOptional()
    @IsArray()
    maritalStatuses: number[];
    /**
     * 子供の有無
     */
    @IsOptional()
    hasChildren: number;
    /**
     * 家事
     */
    @IsOptional()
    @IsArray()
    houseworks: number[];
    /**
     * 子供がほしいか
     */
    @IsOptional()
    @IsArray()
    wantChildren: number[];
    /**
     * 育児
     */
    @IsOptional()
    @IsArray()
    parentings: number[];
    /**
     * 休日
     */
    @IsOptional()
    @IsArray()
    holidays: number[];
    /**
     * 飲酒の習慣
     */
    @IsOptional()
    @IsArray()
    drinkings: number[];
    /**
     * 喫煙の習慣
     */
    @IsOptional()
    @IsArray()
    smokings: number[];
    /**
     * 趣味
     */
    @IsOptional()
    @IsArray()
    hobbies: number[];
    /**
     * 話せる言語
     */
    @IsOptional()
    @IsArray()
    languages: number[];
    /**
     * 年収証明書
     */
    @IsOptional()
    @IsBoolean()
    incomeVerified: boolean;
    /**
     * 学歴証明書
     */
    @IsOptional()
    @IsBoolean()
    educationVerified: boolean;
    /**
     * 独身証明書
     */
    @IsOptional()
    @IsBoolean()
    unmarriedStatusVerified: boolean;
}
export class GetUsersCountQueryValidator {
    /**
     * 課金中
     */
    @IsOptional()
    @IsBoolean()
    isPaid: boolean;
    /**
     * c-ship中
     */
    @IsOptional()
    @IsBoolean()
    isCShip: boolean;
    /**
     * 居住地
     */
    @IsOptional()
    @IsArray()
    residences: number[];
    /**
     * 出身地
     */
    @IsOptional()
    @IsArray()
    birthplaces: number[];
    /**
     * 年齢下限
     */
    @IsOptional()
    @IsInt()
    ageFrom: number;
    /**
     * 年齢上限
     */
    @IsOptional()
    @IsInt()
    ageTo: number;
    /**
     * 身長下限
     */
    @IsOptional()
    @IsInt()
    heightsFrom: number;
    /**
     * 身長上限
     */
    @IsOptional()
    @IsInt()
    heightsTo: number;
    /**
     * 体型
     */
    @IsOptional()
    @IsArray()
    figures: number[];
    /**
     * 血液型
     */
    @IsOptional()
    @IsArray()
    bloodTypes: number[];
    /**
     * 職種
     */
    @IsOptional()
    @IsArray()
    occupations: number[];
    /**
     * 年収下限
     */
    @IsOptional()
    @IsInt()
    incomeFrom: number;
    /**
     * 年収上限
     */
    @IsOptional()
    @IsInt()
    incomeTo: number;
    /**
     * 学歴
     */
    @IsOptional()
    @IsArray()
    educations: number[];
    /**
     * 結婚歴
     */
    @IsOptional()
    @IsArray()
    maritalStatuses: number[];
    /**
     * 子供の有無
     */
    @IsOptional()
    hasChildren: number;
    /**
     * 家事
     */
    @IsOptional()
    @IsArray()
    houseworks: number[];
    /**
     * 子供がほしいか
     */
    @IsOptional()
    @IsArray()
    wantChildren: number[];
    /**
     * 育児
     */
    @IsOptional()
    @IsArray()
    parentings: number[];
    /**
     * 休日
     */
    @IsOptional()
    @IsArray()
    holidays: number[];
    /**
     * 飲酒の習慣
     */
    @IsOptional()
    @IsArray()
    drinkings: number[];
    /**
     * 喫煙の習慣
     */
    @IsOptional()
    @IsArray()
    smokings: number[];
    /**
     * 趣味
     */
    @IsOptional()
    @IsArray()
    hobbies: number[];
    /**
     * 話せる言語
     */
    @IsOptional()
    @IsArray()
    languages: number[];
    /**
     * 年収証明書
     */
    @IsOptional()
    @IsBoolean()
    incomeVerified: boolean;
    /**
     * 学歴証明書
     */
    @IsOptional()
    @IsBoolean()
    educationVerified: boolean;
    /**
     * 独身証明書
     */
    @IsOptional()
    @IsBoolean()
    unmarriedStatusVerified: boolean;
}
export class PostUsersBlockRequestBodyValidator {
    /**
     * targetUserId
     */
    @IsNotEmpty()
    targetUserId: string;
}
export class PostUsersReportRequestBodyValidator {
    /**
     * targetUserId
     */
    @IsNotEmpty()
    targetUserId: string;
    /**
     * type
     */
    @IsNotEmpty()
    @IsIn(Object.values(ReportType))
    type: ReportType;
    /**
     * detail
     */
    @IsNotEmpty()
    @MaxLength(200)
    detail: string;
}
export class GetMyLikesQueryValidator {
    /**
     * from userId for next page
     */
    @IsOptional()
    @IsInt()
    page: number;
    /**
     * Users limit
     */
    @IsOptional()
    @IsInt()
    limit: number;
}
export class GetMyLikersQueryValidator {
    /**
     * total get count
     */
    @IsOptional()
    offset: number;
    /**
     * Users Sort Type
     */
    @IsOptional()
    @IsInt()
    sortType: number;
    /**
     * 居住地
     */
    @IsOptional()
    @IsArray()
    residences: number[];
    /**
     * 出身地
     */
    @IsOptional()
    @IsArray()
    birthplaces: number[];
    /**
     * 年齢下限
     */
    @IsOptional()
    @IsInt()
    ageFrom: number;
    /**
     * 年齢上限
     */
    @IsOptional()
    @IsInt()
    ageTo: number;
    /**
     * 身長下限
     */
    @IsOptional()
    @IsInt()
    heightsFrom: number;
    /**
     * 身長上限
     */
    @IsOptional()
    @IsInt()
    heightsTo: number;
    /**
     * 体型
     */
    @IsOptional()
    @IsArray()
    figures: number[];
    /**
     * 血液型
     */
    @IsOptional()
    @IsArray()
    bloodTypes: number[];
    /**
     * 職種
     */
    @IsOptional()
    @IsArray()
    occupations: number[];
    /**
     * 年収下限
     */
    @IsOptional()
    @IsInt()
    incomeFrom: number;
    /**
     * 年収上限
     */
    @IsOptional()
    @IsInt()
    incomeTo: number;
    /**
     * 学歴
     */
    @IsOptional()
    @IsArray()
    educations: number[];
    /**
     * 結婚歴
     */
    @IsOptional()
    @IsArray()
    maritalStatuses: number[];
    /**
     * 子供の有無
     */
    @IsOptional()
    hasChildren: number;
    /**
     * 家事
     */
    @IsOptional()
    @IsArray()
    houseworks: number[];
    /**
     * 子供がほしいか
     */
    @IsOptional()
    @IsArray()
    wantChildren: number[];
    /**
     * 育児
     */
    @IsOptional()
    @IsArray()
    parentings: number[];
    /**
     * 休日
     */
    @IsOptional()
    @IsArray()
    holidays: number[];
    /**
     * 飲酒の習慣
     */
    @IsOptional()
    @IsArray()
    drinkings: number[];
    /**
     * 喫煙の習慣
     */
    @IsOptional()
    @IsArray()
    smokings: number[];
    /**
     * 趣味
     */
    @IsOptional()
    @IsArray()
    hobbies: number[];
    /**
     * 話せる言語
     */
    @IsOptional()
    @IsArray()
    languages: number[];
    /**
     * 年収証明書
     */
    @IsOptional()
    @IsBoolean()
    incomeVerified: boolean;
    /**
     * 学歴証明書
     */
    @IsOptional()
    @IsBoolean()
    educationVerified: boolean;
    /**
     * 独身証明書
     */
    @IsOptional()
    @IsBoolean()
    unmarriedStatusVerified: boolean;
    /**
     * 一覧取得日時
     */
    @IsOptional()
    @Type(() => Date)
    listGetTime: Date;
}
export class GetMySkipUsersQueryValidator {
    /**
     * total get count
     */
    @IsOptional()
    offset: number;
}
export class GetMyLikersCountQueryValidator {
    /**
     * 居住地
     */
    @IsOptional()
    @IsArray()
    residences: number[];
    /**
     * 出身地
     */
    @IsOptional()
    @IsArray()
    birthplaces: number[];
    /**
     * 年齢下限
     */
    @IsOptional()
    @IsInt()
    ageFrom: number;
    /**
     * 年齢上限
     */
    @IsOptional()
    @IsInt()
    ageTo: number;
    /**
     * 身長下限
     */
    @IsOptional()
    @IsInt()
    heightsFrom: number;
    /**
     * 身長上限
     */
    @IsOptional()
    @IsInt()
    heightsTo: number;
    /**
     * 体型
     */
    @IsOptional()
    @IsArray()
    figures: number[];
    /**
     * 血液型
     */
    @IsOptional()
    @IsArray()
    bloodTypes: number[];
    /**
     * 職種
     */
    @IsOptional()
    @IsArray()
    occupations: number[];
    /**
     * 年収下限
     */
    @IsOptional()
    @IsInt()
    incomeFrom: number;
    /**
     * 年収上限
     */
    @IsOptional()
    @IsInt()
    incomeTo: number;
    /**
     * 学歴
     */
    @IsOptional()
    @IsArray()
    educations: number[];
    /**
     * 結婚歴
     */
    @IsOptional()
    @IsArray()
    maritalStatuses: number[];
    /**
     * 子供の有無
     */
    @IsOptional()
    hasChildren: number;
    /**
     * 家事
     */
    @IsOptional()
    @IsArray()
    houseworks: number[];
    /**
     * 子供がほしいか
     */
    @IsOptional()
    @IsArray()
    wantChildren: number[];
    /**
     * 育児
     */
    @IsOptional()
    @IsArray()
    parentings: number[];
    /**
     * 休日
     */
    @IsOptional()
    @IsArray()
    holidays: number[];
    /**
     * 飲酒の習慣
     */
    @IsOptional()
    @IsArray()
    drinkings: number[];
    /**
     * 喫煙の習慣
     */
    @IsOptional()
    @IsArray()
    smokings: number[];
    /**
     * 趣味
     */
    @IsOptional()
    @IsArray()
    hobbies: number[];
    /**
     * 話せる言語
     */
    @IsOptional()
    @IsArray()
    languages: number[];
    /**
     * 年収証明書
     */
    @IsOptional()
    @IsBoolean()
    incomeVerified: boolean;
    /**
     * 学歴証明書
     */
    @IsOptional()
    @IsBoolean()
    educationVerified: boolean;
    /**
     * 独身証明書
     */
    @IsOptional()
    @IsBoolean()
    unmarriedStatusVerified: boolean;
}
export class SkipMyLikerRequestBodyValidator {
    /**
     * likerUserId
     */
    @IsNotEmpty()
    likerUserId: string;
}
export class SkipMyLikersQueryValidator {
    /**
     * 居住地
     */
    @IsOptional()
    @IsArray()
    residences: number[];
    /**
     * 出身地
     */
    @IsOptional()
    @IsArray()
    birthplaces: number[];
    /**
     * 年齢下限
     */
    @IsOptional()
    @IsInt()
    ageFrom: number;
    /**
     * 年齢上限
     */
    @IsOptional()
    @IsInt()
    ageTo: number;
    /**
     * 身長下限
     */
    @IsOptional()
    @IsInt()
    heightsFrom: number;
    /**
     * 身長上限
     */
    @IsOptional()
    @IsInt()
    heightsTo: number;
    /**
     * 体型
     */
    @IsOptional()
    @IsArray()
    figures: number[];
    /**
     * 血液型
     */
    @IsOptional()
    @IsArray()
    bloodTypes: number[];
    /**
     * 職種
     */
    @IsOptional()
    @IsArray()
    occupations: number[];
    /**
     * 年収下限
     */
    @IsOptional()
    @IsInt()
    incomeFrom: number;
    /**
     * 年収上限
     */
    @IsOptional()
    @IsInt()
    incomeTo: number;
    /**
     * 学歴
     */
    @IsOptional()
    @IsArray()
    educations: number[];
    /**
     * 結婚歴
     */
    @IsOptional()
    @IsArray()
    maritalStatuses: number[];
    /**
     * 子供の有無
     */
    @IsOptional()
    hasChildren: number;
    /**
     * 家事
     */
    @IsOptional()
    @IsArray()
    houseworks: number[];
    /**
     * 子供がほしいか
     */
    @IsOptional()
    @IsArray()
    wantChildren: number[];
    /**
     * 育児
     */
    @IsOptional()
    @IsArray()
    parentings: number[];
    /**
     * 休日
     */
    @IsOptional()
    @IsArray()
    holidays: number[];
    /**
     * 飲酒の習慣
     */
    @IsOptional()
    @IsArray()
    drinkings: number[];
    /**
     * 喫煙の習慣
     */
    @IsOptional()
    @IsArray()
    smokings: number[];
    /**
     * 趣味
     */
    @IsOptional()
    @IsArray()
    hobbies: number[];
    /**
     * 話せる言語
     */
    @IsOptional()
    @IsArray()
    languages: number[];
    /**
     * 年収証明書
     */
    @IsOptional()
    @IsBoolean()
    incomeVerified: boolean;
    /**
     * 学歴証明書
     */
    @IsOptional()
    @IsBoolean()
    educationVerified: boolean;
    /**
     * 独身証明書
     */
    @IsOptional()
    @IsBoolean()
    unmarriedStatusVerified: boolean;
    /**
     * 一覧取得日時
     */
    @IsOptional()
    @Type(() => Date)
    listGetTime: Date;
}
export class PostLikeRequestBodyValidator {
    /**
     * targetUserId
     */
    @IsNotEmpty()
    targetUserId: string;
    /**
     * isReturnLike
     */
    @IsOptional()
    @IsBoolean()
    isReturnLike: boolean;
}
export class GetMyChatsQueryValidator {
    /**
     * page
     */
    @IsOptional()
    page: number;
}
export class GetMyClosedChatsQueryValidator {
    /**
     * page
     */
    @IsOptional()
    page: number;
}
export class GetChatMessagesQueryValidator {
    /**
     * 前回取得した最古のチャットID
     */
    @IsOptional()
    previousOldestMessageId: number;
}
export class PostChatMessagesRequestBodyValidator {
    /**
     * message
     */
    @IsNotEmpty()
    @MaxLength(1000)
    message: string;
}
export class CloseChatRoomRequestBodyValidator {
    /**
     * chatId
     */
    @IsNotEmpty()
    chatId: number;
    /**
     * closeReasons
     */
    @IsNotEmpty()
    @IsArray()
    @IsIn(Object.values(ChatCloseReason), { each: true })
    closeReasons: ChatCloseReason[];
    /**
     * closeReasonDetail
     */
    @IsOptional()
    @MaxLength(200)
    closeReasonDetail: string;
}
export class PutChatMessagesReadRequestBodyValidator {
    /**
     * messageId
     */
    @IsNotEmpty()
    messageId: number;
}
export class GetConciergeChatMessagesQueryValidator {
    /**
     * 前回取得した最古のチャットID
     */
    @IsOptional()
    previousOldestMessageId: number;
}
export class PostConciergeChatMessagesRequestBodyValidator {
    /**
     * message
     */
    @IsNotEmpty()
    message: string;
}
export class PutConciergeChatMessagesReadRequestBodyValidator {
    /**
     * conciergeMessageId
     */
    @IsNotEmpty()
    conciergeMessageId: number;
}
export class PostImageFilenameInConciergeChatRequestBodyValidator {
    /**
     * filename
     */
    @IsNotEmpty()
    filename: string;
}
export class RequestWithdrawalRequestBodyValidator {
    /**
     * reasons
     */
    @IsNotEmpty()
    @IsArray()
    @IsIn(Object.values(WithdrawalRequestReason), { each: true })
    reasons: WithdrawalRequestReason[];
    /**
     * opinion
     */
    @IsOptional()
    @MaxLength(300)
    opinion: string;
}
export class PostSingleCertAgentRequestBodyValidator {
    /**
     * isForeignNationality
     */
    @IsOptional()
    @IsBoolean()
    isForeignNationality: boolean;
    /**
     * zip
     */
    @IsNotEmpty()
    @Length(7, 7)
    zip: string;
    /**
     * pref
     */
    @IsNotEmpty()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * city
     */
    @IsNotEmpty()
    @MaxLength(48)
    city: string;
    /**
     * address
     */
    @IsNotEmpty()
    @MaxLength(25)
    address: string;
    /**
     * building
     */
    @IsOptional()
    @MaxLength(25)
    building: string;
    /**
     * principalFamilyName
     */
    @IsNotEmpty()
    @MaxLength(24)
    principalFamilyName: string;
    /**
     * principalGivenName
     */
    @IsNotEmpty()
    @MaxLength(24)
    principalGivenName: string;
    /**
     * principalFamilyNameKana
     */
    @IsNotEmpty()
    @MaxLength(24)
    principalFamilyNameKana: string;
    /**
     * principalGivenNameKana
     */
    @IsNotEmpty()
    @MaxLength(24)
    principalGivenNameKana: string;
    /**
     * relationship
     */
    @IsNotEmpty()
    @MaxLength(10)
    relationship: string;
    /**
     * permanentZip
     */
    @IsNotEmpty()
    @Length(7, 7)
    permanentZip: string;
    /**
     * permanentPref
     */
    @IsNotEmpty()
    @IsIn(Object.values(Prefecture))
    permanentPref: Prefecture;
    /**
     * permanentCity
     */
    @IsNotEmpty()
    @MaxLength(48)
    permanentCity: string;
    /**
     * permanentAddress
     */
    @IsNotEmpty()
    @MaxLength(25)
    permanentAddress: string;
    /**
     * permanentBuilding
     */
    @IsOptional()
    @MaxLength(25)
    permanentBuilding: string;
}
export class PutUserAddressRequestBodyValidator {
    /**
     * zip
     */
    @IsNotEmpty()
    @Length(7, 7)
    zip: string;
    /**
     * pref
     */
    @IsNotEmpty()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * city
     */
    @IsNotEmpty()
    @MaxLength(48)
    city: string;
    /**
     * address
     */
    @IsNotEmpty()
    @MaxLength(25)
    address: string;
    /**
     * building
     */
    @IsOptional()
    @MaxLength(25)
    building: string;
}
export class PutFootprintRequestBodyValidator {
    /**
     * targetUserId
     */
    @IsNotEmpty()
    targetUserId: string;
}
export class PutFootprintSeenRequestBodyValidator {
    /**
     * lastSeenFootprintId
     */
    @IsNotEmpty()
    lastSeenFootprintId: number;
}
export class PutPaymentCreditCardZeusRequestBodyValidator {
    /**
     * Zeusトークンキー
     */
    @IsNotEmpty()
    @Length(86, 86)
    @Matches(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/)
    tokenKey: string;
}
export class CurrentPaymentState1Validator {
    /**
     * paymentType
     */
    @IsNotEmpty()
    @IsIn(Object.values(PaymentType))
    paymentType: PaymentType;
    /**
     * paymentPlanId
     */
    @IsNotEmpty()
    @ValidateIf(o => o.paymentPlanId !== null)
    @IsIn(Object.values(PaymentPlanEnum))
    paymentPlanId: PaymentPlanEnum;
    /**
     * paymentMethod
     */
    @IsNotEmpty()
    @ValidateIf(o => o.paymentMethod !== null)
    @IsIn(Object.values(PaymentMethodEnum))
    paymentMethod: PaymentMethodEnum;
}
export class NewPayment1Validator {
    /**
     * paymentPlanId
     */
    @IsNotEmpty()
    @IsIn(Object.values(PaymentPlanEnum))
    paymentPlanId: PaymentPlanEnum;
    /**
     * campaignId
     */
    @IsNotEmpty()
    @ValidateIf(o => o.campaignId !== null)
    campaignId: string;
    /**
     * amount
     */
    @IsNotEmpty()
    amount: number;
    /**
     * firstAmount
     */
    @IsNotEmpty()
    @ValidateIf(o => o.firstAmount !== null)
    firstAmount: number;
}
export class PostPaymentZeusSubscribeRequestBodyValidator {
    /**
     * currentPaymentState
     */
    @IsNotEmpty()
    @ValidateNested()
    @Type(() => CurrentPaymentState1Validator)
    currentPaymentState: {
        paymentType: PaymentType;
        paymentPlanId: PaymentPlanEnum | null;
        paymentMethod: PaymentMethodEnum | null;
    };
    /**
     * newPayment
     */
    @IsNotEmpty()
    @ValidateNested()
    @Type(() => NewPayment1Validator)
    newPayment: {
        paymentPlanId: PaymentPlanEnum;
        campaignId: string | null;
        amount: number;
        firstAmount: number | null;
    };
}
export class PostPaymentErrorLogRequestBodyValidator {
    /**
     * token: トークンエラー payment: オーソリエラー
     */
    @IsNotEmpty()
    errorType: string;
    /**
     * Zeus決済結果ステータス
     */
    @IsNotEmpty()
    status: string;
    /**
     * Zeus決済結果エラーコード
     */
    @IsNotEmpty()
    code: string;
}
export class PostTransferToCardRequestBodyValidator {
    /**
     * Zeusトークンキー
     */
    @IsNotEmpty()
    @Length(86, 86)
    @Matches(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/)
    tokenKey: string;
}
export class PostThreeDSecureEnrollRequestBodyValidator {
    /**
     * ZEUS Token APIで取得したトークンキー
     */
    @IsNotEmpty()
    tokenKey: string;
    /**
     * 支払方法コード（デフォルト 01 一括払い）
     */
    @IsOptional()
    count: string;
    /**
     * カード名義人名（ローマ字、リスクベース認証用）
     */
    @IsOptional()
    cardholderName: string;
    /**
     * カード名義人メールアドレス（リスクベース認証用）
     */
    @IsOptional()
    cardholderEmail: string;
    /**
     * カード名義人携帯電話国コード（リスクベース認証用、例 81）
     */
    @IsOptional()
    cardholderMobilePhoneCountryCode: string;
    /**
     * カード名義人携帯電話番号（リスクベース認証用、ハイフンなし）
     */
    @IsOptional()
    cardholderMobilePhoneNumber: string;
}
export class PostThreeDSecurePayRequestBodyValidator {
    /**
     * 3DSセッションID
     */
    @IsNotEmpty()
    sessionId: string;
    /**
     * 認証ステータス（Y/N/U/A/C/R）
     */
    @IsNotEmpty()
    transStatus: string;
    /**
     * ECインジケータ
     */
    @IsOptional()
    eci: string;
    /**
     * 認証値（CAVV/AAV）
     */
    @IsOptional()
    authenticationValue: string;
}
export class PostThreeDSecureQuickEnrollRequestBodyValidator {
    /**
     * 登録済みカードID（ZEUS sendid）
     */
    @IsNotEmpty()
    sendid: string;
    /**
     * セキュリティコードトークン（CVV入力時のみ）
     */
    @IsOptional()
    tokenKey: string;
    /**
     * 支払方法コード（デフォルト 01 一括払い）
     */
    @IsOptional()
    count: string;
}
export class PostThreeDSecureQuickPayRequestBodyValidator {
    /**
     * 3DSセッションID
     */
    @IsNotEmpty()
    sessionId: string;
    /**
     * 登録済みカードID（ZEUS sendid）
     */
    @IsNotEmpty()
    sendid: string;
    /**
     * 認証ステータス（Y/N/U/A/C/R）
     */
    @IsNotEmpty()
    transStatus: string;
    /**
     * ECインジケータ
     */
    @IsOptional()
    eci: string;
    /**
     * 認証値（CAVV/AAV）
     */
    @IsOptional()
    authenticationValue: string;
}
export class RegisterPaymentAddressRequestBodyValidator {
    /**
     * 郵便番号
     */
    @IsNotEmpty()
    @Length(7, 7)
    @Matches(/^[0-9]+$/)
    zip: string;
    /**
     * pref
     */
    @IsNotEmpty()
    @IsIn(Object.values(Prefecture))
    pref: Prefecture;
    /**
     * 市区町村
     */
    @IsNotEmpty()
    city: string;
    /**
     * 住所
     */
    @IsNotEmpty()
    address: string;
    /**
     * 建物名、号室
     */
    @IsOptional()
    building: string;
}
export class PutMyPartnerConditionRequestBodyValidator {
    /**
     * prefArea
     */
    @IsOptional()
    @IsArray()
    prefArea: string[];
    /**
     * ageFrom
     */
    @IsOptional()
    ageFrom: number;
    /**
     * ageTo
     */
    @IsOptional()
    ageTo: number;
    /**
     * annualIncomeFrom
     */
    @IsOptional()
    annualIncomeFrom: number;
    /**
     * annualIncomeTo
     */
    @IsOptional()
    annualIncomeTo: number;
    /**
     * heightFrom
     */
    @IsOptional()
    heightFrom: number;
    /**
     * heightTo
     */
    @IsOptional()
    heightTo: number;
    /**
     * education
     */
    @IsOptional()
    @IsArray()
    education: number[];
    /**
     * marriage
     */
    @IsOptional()
    marriage: string;
    /**
     * child
     */
    @IsOptional()
    child: string;
    /**
     * smoke
     */
    @IsOptional()
    @IsIn(Object.values(SmokingPartnerCondition))
    smoke: SmokingPartnerCondition;
    /**
     * emphasis
     */
    @IsOptional()
    @IsArray()
    @IsIn(Object.values(EmphasisPartnerCondition), { each: true })
    emphasis: EmphasisPartnerCondition[];
}
export class GetPromotionsQueryValidator {
    /**
     * platform
     */
    @IsOptional()
    @IsIn(Object.values(PromotionPlatformEnum))
    platform: PromotionPlatformEnum;
}
export class PutMyMarriageActivityStatusRequestBodyValidator {
    /**
     * marriageTiming
     */
    @IsNotEmpty()
    @IsIn(Object.values(MarriageActivityMarriageTiming))
    marriageTiming: MarriageActivityMarriageTiming;
    /**
     * usedMarriageServices
     */
    @IsNotEmpty()
    @IsArray()
    @IsIn(Object.values(MarriageActivityUsedMarriageServices), { each: true })
    usedMarriageServices: MarriageActivityUsedMarriageServices[];
    /**
     * recentIssues
     */
    @IsNotEmpty()
    @IsArray()
    @IsIn(Object.values(MarriageActivityRecentIssues), { each: true })
    recentIssues: MarriageActivityRecentIssues[];
    /**
     * desiredServices
     */
    @IsNotEmpty()
    @IsArray()
    @IsIn(Object.values(MarriageActivityDesiredServices), { each: true })
    desiredServices: MarriageActivityDesiredServices[];
}
export default class APIAgent {
    httpClient: HTTPClient;
    constructor(httpClient: HTTPClient) {
        this.httpClient = httpClient;
    }
    /**
     * Health Check
     */
    async getHealthCheck() {
        return (await this.httpClient.get(
            "/",
            {}
        )) as GetHealthCheckResponseBody;
    }
    /**
     * Get Versions
     */
    async getVersions() {
        return (await this.httpClient.get(
            "/versions",
            {}
        )) as GetVersionsResponseBody;
    }
    /**
     * Get S3 Signed URL
     */
    async getSignedUrl() {
        return (await this.httpClient.post(
            "/s3",
            {},
            {}
        )) as GetSignedUrlResponseBody;
    }
    /**
     * Get S3 Signed URL Confidential
     */
    async getSignedUrlConfidential(body: GetSignedUrlConfidentialRequestBody) {
        return (await this.httpClient.post(
            "/s3/confidential",
            body,
            {}
        )) as GetSignedUrlConfidentialResponseBody;
    }
    /**
     * Get S3 Signed Url In Concierge Chat
     */
    async getS3SignedUrlInConciergeChat(
        body: GetS3SignedUrlInConciergeChatRequestBody
    ) {
        return (await this.httpClient.post(
            "/s3/concierge_chats",
            body,
            {}
        )) as GetS3SignedUrlInConciergeChatResponseBody;
    }
    /**
     * Get Download S3 Signed Url In Concierge Chat
     */
    async getDownloadS3SignedUrlInConciergeChat(
        query: GetDownloadS3SignedUrlInConciergeChatQuery
    ) {
        return (await this.httpClient.post(
            "/s3/concierge_chats/images",
            {},
            query
        )) as GetDownloadS3SignedUrlInConciergeChatResponseBody;
    }
    /**
     * Get My Notices
     */
    async getMyNotices(query: GetMyNoticesQuery) {
        return (await this.httpClient.get(
            "/my_notice",
            query
        )) as GetMyNoticesResponseBody;
    }
    /**
     * Post CounselingReservation
     */
    async postCounselingReservation(
        body: PostCounselingReservationRequestBody
    ) {
        return (await this.httpClient.post(
            "/counseling_reservation",
            body,
            {}
        )) as PostCounselingReservationResponseBody;
    }
    /**
     * Post Counseling Video
     */
    async postCounselingVideo() {
        return (await this.httpClient.post(
            "/counseling_reservation/video",
            {},
            {}
        )) as PostCounselingVideoResponseBody;
    }
    /**
     * Get My Settings
     */
    async getMySettings() {
        return (await this.httpClient.get(
            "/my_settings",
            {}
        )) as GetMySettingsResponseBody;
    }
    /**
     * Put My Settings
     */
    async putMySettings(body: PutMySettingsRequestBody) {
        return (await this.httpClient.put(
            "/my_settings",
            body,
            {}
        )) as PutMySettingsResponseBody;
    }
    /**
     * Put My Settings Push Notifications
     */
    async putMySettingsPushNotifications(
        body: PutMySettingsPushNotificationsRequestBody
    ) {
        return (await this.httpClient.put(
            "/my_settings/push_notifications",
            body,
            {}
        )) as PutMySettingsPushNotificationsResponseBody;
    }
    /**
     * Put My Settings Change phone
     */
    async putMySettingsPhone(body: PutMySettingsPhoneRequestBody) {
        return (await this.httpClient.put(
            "/my_settings/phone",
            body,
            {}
        )) as PutMySettingsPhoneResponseBody;
    }
    /**
     * Put My Notice Seen
     */
    async putMyNoticeSeen(body: PutMyNoticeSeenRequestBody) {
        return (await this.httpClient.put(
            "/my_notice/seen",
            body,
            {}
        )) as PutMyNoticeSeenResponseBody;
    }
    /**
     * Get Identify Review Reject
     */
    async getIdentifyReviewReject() {
        return (await this.httpClient.get(
            "/identify_review",
            {}
        )) as GetIdentifyReviewRejectResponseBody;
    }
    /**
     * Put Identify Review
     */
    async putIdentifyReview(body: PutIdentifyReviewRequestBody) {
        return (await this.httpClient.put(
            "/identify_review",
            body,
            {}
        )) as PutIdentifyReviewResponseBody;
    }
    /**
     * Resubmit Identify（clear reject reasons）
     */
    async patchIdentifyReviewResubmit() {
        return (await this.httpClient.patch(
            "/identify_review/resubmit",
            {},
            {}
        )) as PatchIdentifyReviewResubmitResponseBody;
    }
    /**
     * Post Document Review
     */
    async postDocumentReview(body: PostDocumentReviewRequestBody) {
        return (await this.httpClient.post(
            "/document_review",
            body,
            {}
        )) as PostDocumentReviewResponseBody;
    }
    /**
     * Verify IAP Receipt
     */
    async verifyReceipt(body: VerifyReceiptRequestBody) {
        return (await this.httpClient.post(
            "/iap/receipt/validate",
            body,
            {}
        )) as VerifyReceiptResponseBody;
    }
    /**
     * Get My User
     */
    async getMyUser() {
        return (await this.httpClient.get(
            "/user",
            {}
        )) as GetMyUserResponseBody;
    }
    /**
     * Post My User
     */
    async postMyUser(body: PostMyUserRequestBody) {
        return (await this.httpClient.post(
            "/user",
            body,
            {}
        )) as PostMyUserResponseBody;
    }
    /**
     * Patch My User
     */
    async patchMyUser(body: PatchMyUserRequestBody) {
        return (await this.httpClient.patch(
            "/user",
            body,
            {}
        )) as PatchMyUserResponseBody;
    }
    /**
     * Post Paid Register User
     */
    async postPaidRegisterUser(body: PostPaidRegisterUserRequestBody) {
        return (await this.httpClient.post(
            "/user/paid_register",
            body,
            {}
        )) as PostPaidRegisterUserResponseBody;
    }
    /**
     * Get My Search User
     */
    async getMySearchUser() {
        return (await this.httpClient.get(
            "/user/my_search_user",
            {}
        )) as GetMySearchUserResponseBody;
    }
    /**
     * Put My User Basic Info
     */
    async putMyUserBasicInfo(body: PutMyUserBasicInfoRequestBody) {
        return (await this.httpClient.put(
            "/user/basic_info",
            body,
            {}
        )) as PutMyUserBasicInfoResponseBody;
    }
    /**
     * Put Photo For CShip
     */
    async putPhotoForCShip(body: PutPhotoForCShipRequestBody) {
        return (await this.httpClient.put(
            "/user/photo_for_c_ship",
            body,
            {}
        )) as PutPhotoForCShipResponseBody;
    }
    /**
     * Put My User Profile
     */
    async putMyUserProfile(body: PutMyUserProfileRequestBody) {
        return (await this.httpClient.put(
            "/user/profile",
            body,
            {}
        )) as PutMyUserProfileResponseBody;
    }
    /**
     * Request Participate C-ship
     */
    async requestParticipateCShip() {
        return (await this.httpClient.put(
            "/user/request_participate_c_ship",
            {},
            {}
        )) as RequestParticipateCShipResponseBody;
    }
    /**
     * Get C-Ship SSO login URL
     */
    async getCShipSsoLoginUrl() {
        return (await this.httpClient.get(
            "/user/c_ship",
            {}
        )) as GetCShipSsoLoginUrlResponseBody;
    }
    /**
     * Post C-Ship Register Check
     */
    async postCShipRegisterCheck() {
        return (await this.httpClient.get(
            "/user/c_ship/register_check",
            {}
        )) as PostCShipRegisterCheckResponseBody;
    }
    /**
     * Post AV Congeniality Answer
     */
    async postAvCongenialityAnswer(body: PostAvCongenialityAnswerRequestBody) {
        return (await this.httpClient.post(
            "/user/congeniality_answer/av",
            body,
            {}
        )) as PostAvCongenialityAnswerResponseBody;
    }
    /**
     * Post VF Congeniality Answer
     */
    async postVfCongenialityAnswer(body: PostVfCongenialityAnswerRequestBody) {
        return (await this.httpClient.post(
            "/user/congeniality_answer/vf",
            body,
            {}
        )) as PostVfCongenialityAnswerResponseBody;
    }
    /**
     * Post Auth Login
     */
    async postAuthLogin(body: PostAuthLoginRequestBody) {
        return (await this.httpClient.post(
            "/auth/login",
            body,
            {}
        )) as PostAuthLoginResponseBody;
    }
    /**
     * Post Auth Code
     */
    async postAuthCode(body: PostAuthCodeRequestBody) {
        return (await this.httpClient.post(
            "/auth/code",
            body,
            {}
        )) as PostAuthCodeResponseBody;
    }
    /**
     * ユーザーのメルアドを変更するログイン
     */
    async putNewEmailLogin(body: PutNewEmailLoginRequestBody) {
        return (await this.httpClient.put(
            "/auth/new_email/login",
            body,
            {}
        )) as PutNewEmailLoginResponseBody;
    }
    /**
     * ユーザーのメルアドを変更するコード
     */
    async putNewEmailCode(body: PutNewEmailCodeRequestBody) {
        return (await this.httpClient.put(
            "/auth/new_email/code",
            body,
            {}
        )) as PutNewEmailCodeResponseBody;
    }
    /**
     * Get Users
     */
    async getUsers(query: GetUsersQuery) {
        return (await this.httpClient.get(
            "/users",
            query
        )) as GetUsersResponseBody;
    }
    /**
     * Get Users Order By Recommend
     */
    async getUsersOrderByRecommend(query: GetUsersOrderByRecommendQuery) {
        return (await this.httpClient.get(
            "/users/order_by_recommend",
            query
        )) as GetUsersOrderByRecommendResponseBody;
    }
    /**
     * Get Users Count
     */
    async getUsersCount(query: GetUsersCountQuery) {
        return (await this.httpClient.get(
            "/users/count",
            query
        )) as GetUsersCountResponseBody;
    }
    /**
     * Post Users Block
     */
    async postUsersBlock(body: PostUsersBlockRequestBody) {
        return (await this.httpClient.post(
            "/users/block",
            body,
            {}
        )) as PostUsersBlockResponseBody;
    }
    /**
     * Post Users Report
     */
    async postUsersReport(body: PostUsersReportRequestBody) {
        return (await this.httpClient.post(
            "/users/report",
            body,
            {}
        )) as PostUsersReportResponseBody;
    }
    /**
     * Get User By User Id
     */
    async getUserByUserId(userId: string) {
        return (await this.httpClient.get(
            `/users/${userId}`,
            {}
        )) as GetUserByUserIdResponseBody;
    }
    /**
     * Get My Likes
     */
    async getMyLikes(query: GetMyLikesQuery) {
        return (await this.httpClient.get(
            "/my_likes",
            query
        )) as GetMyLikesResponseBody;
    }
    /**
     * Get My Likers
     */
    async getMyLikers(query: GetMyLikersQuery) {
        return (await this.httpClient.get(
            "/my_likes/my_likers",
            query
        )) as GetMyLikersResponseBody;
    }
    /**
     * Get My Skip Users
     */
    async getMySkipUsers(query: GetMySkipUsersQuery) {
        return (await this.httpClient.get(
            "/my_likes/my_skip_users",
            query
        )) as GetMySkipUsersResponseBody;
    }
    /**
     * Get My Likers Count
     */
    async getMyLikersCount(query: GetMyLikersCountQuery) {
        return (await this.httpClient.get(
            "/my_likes/my_likers/count",
            query
        )) as GetMyLikersCountResponseBody;
    }
    /**
     * skip My Liker
     */
    async skipMyLiker(body: SkipMyLikerRequestBody) {
        return (await this.httpClient.put(
            "/my_likes/my_likers/skip_my_liker",
            body,
            {}
        )) as SkipMyLikerResponseBody;
    }
    /**
     * skip My Likers
     */
    async skipMyLikers(query: SkipMyLikersQuery) {
        return (await this.httpClient.put(
            "/my_likes/my_likers/skip_my_likers",
            {},
            query
        )) as SkipMyLikersResponseBody;
    }
    /**
     * Get My Like Stock
     */
    async getMyLikeStock() {
        return (await this.httpClient.get(
            "/like_stock",
            {}
        )) as GetMyLikeStockResponseBody;
    }
    /**
     * Post Like
     */
    async postLike(body: PostLikeRequestBody) {
        return (await this.httpClient.post(
            "/likes",
            body,
            {}
        )) as PostLikeResponseBody;
    }
    /**
     * Get My Chats
     */
    async getMyChats(query: GetMyChatsQuery) {
        return (await this.httpClient.get(
            "/my_chats",
            query
        )) as GetMyChatsResponseBody;
    }
    /**
     * Get My Closed Chats
     */
    async getMyClosedChats(query: GetMyClosedChatsQuery) {
        return (await this.httpClient.get(
            "/my_chats/closed",
            query
        )) as GetMyClosedChatsResponseBody;
    }
    /**
     * Get Chat Messages
     */
    async getChatMessages(chatId: number, query: GetChatMessagesQuery) {
        return (await this.httpClient.get(
            `/my_chats/${chatId}`,
            query
        )) as GetChatMessagesResponseBody;
    }
    /**
     * Post Chat Messages
     */
    async postChatMessages(chatId: number, body: PostChatMessagesRequestBody) {
        return (await this.httpClient.post(
            `/my_chats/${chatId}`,
            body,
            {}
        )) as PostChatMessagesResponseBody;
    }
    /**
     * Close Chat Room
     */
    async closeChatRoom(body: CloseChatRoomRequestBody) {
        return (await this.httpClient.put(
            "/my_chats/close",
            body,
            {}
        )) as CloseChatRoomResponseBody;
    }
    /**
     * Put Chat Messages Read
     */
    async putChatMessagesRead(
        chatId: number,
        body: PutChatMessagesReadRequestBody
    ) {
        return (await this.httpClient.put(
            `/my_chats/${chatId}/read`,
            body,
            {}
        )) as PutChatMessagesReadResponseBody;
    }
    /**
     * Get Unread Chats
     */
    async getUnreadChats() {
        return (await this.httpClient.get(
            "/my_chats/unread_chats",
            {}
        )) as GetUnreadChatsResponseBody;
    }
    /**
     * Get Concierge Chat
     */
    async getConciergeChat() {
        return (await this.httpClient.get(
            "/concierge_chat",
            {}
        )) as GetConciergeChatResponseBody;
    }
    /**
     * Get Concierge Chat Messages
     */
    async getConciergeChatMessages(
        conciergeChatId: number,
        query: GetConciergeChatMessagesQuery
    ) {
        return (await this.httpClient.get(
            `/concierge_chat/${conciergeChatId}`,
            query
        )) as GetConciergeChatMessagesResponseBody;
    }
    /**
     * Post Concierge Chat Messages
     */
    async postConciergeChatMessages(
        conciergeChatId: number,
        body: PostConciergeChatMessagesRequestBody
    ) {
        return (await this.httpClient.post(
            `/concierge_chat/${conciergeChatId}`,
            body,
            {}
        )) as PostConciergeChatMessagesResponseBody;
    }
    /**
     * Put Concierge Chat Messages read
     */
    async putConciergeChatMessagesRead(
        conciergeChatId: number,
        body: PutConciergeChatMessagesReadRequestBody
    ) {
        return (await this.httpClient.put(
            `/concierge_chat/${conciergeChatId}/read`,
            body,
            {}
        )) as PutConciergeChatMessagesReadResponseBody;
    }
    /**
     * Get Concierge Schedule
     */
    async getConciergeSchedule(conciergeProfileId: number) {
        return (await this.httpClient.get(
            `/concierge_chat/schedules/${conciergeProfileId}`,
            {}
        )) as GetConciergeScheduleResponseBody;
    }
    /**
     * Post Image Filename In Concierge Chat
     */
    async postImageFilenameInConciergeChat(
        conciergeChatId: number,
        body: PostImageFilenameInConciergeChatRequestBody
    ) {
        return (await this.httpClient.post(
            `/concierge_chat/image/${conciergeChatId}`,
            body,
            {}
        )) as PostImageFilenameInConciergeChatResponseBody;
    }
    /**
     * Get Is Applying Withdrawal
     */
    async getIsApplyingWithdrawal() {
        return (await this.httpClient.get(
            "/withdrawal_apply",
            {}
        )) as GetIsApplyingWithdrawalResponseBody;
    }
    /**
     * Request Withdrawal
     */
    async requestWithdrawal(body: RequestWithdrawalRequestBody) {
        return (await this.httpClient.put(
            "/withdrawal_apply",
            body,
            {}
        )) as RequestWithdrawalResponseBody;
    }
    /**
     * Post Single Cert Agent
     */
    async postSingleCertAgent(body: PostSingleCertAgentRequestBody) {
        return (await this.httpClient.post(
            "/single_cert_agent",
            body,
            {}
        )) as PostSingleCertAgentResponseBody;
    }
    /**
     * Put User Address
     */
    async putUserAddress(body: PutUserAddressRequestBody) {
        return (await this.httpClient.put(
            "/user_address",
            body,
            {}
        )) as PutUserAddressResponseBody;
    }
    /**
     * Get User Address
     */
    async getUserAddress() {
        return (await this.httpClient.get(
            "/user_address",
            {}
        )) as GetUserAddressResponseBody;
    }
    /**
     * Get My Footprint
     */
    async getMyFootprint() {
        return (await this.httpClient.get(
            "/footprint",
            {}
        )) as GetMyFootprintResponseBody;
    }
    /**
     * Put footprint
     */
    async putFootprint(body: PutFootprintRequestBody) {
        return (await this.httpClient.put(
            "/footprint",
            body,
            {}
        )) as PutFootprintResponseBody;
    }
    /**
     * Put Footprint Seen
     */
    async putFootprintSeen(body: PutFootprintSeenRequestBody) {
        return (await this.httpClient.put(
            "/footprint/seen",
            body,
            {}
        )) as PutFootprintSeenResponseBody;
    }
    /**
     * Put CreditCard Payment for Zeus
     */
    async putPaymentCreditCardZeus(body: PutPaymentCreditCardZeusRequestBody) {
        return (await this.httpClient.put(
            "/zeus/payment/credit_card",
            body,
            {}
        )) as PutPaymentCreditCardZeusResponseBody;
    }
    /**
     * Post Payment for Zeus Subscribe
     */
    async postPaymentZeusSubscribe(body: PostPaymentZeusSubscribeRequestBody) {
        return (await this.httpClient.post(
            "/zeus/payment/subscribe",
            body,
            {}
        )) as PostPaymentZeusSubscribeResponseBody;
    }
    /**
     * Post Token/Payment Error Logs for Zeus
     */
    async postPaymentErrorLog(body: PostPaymentErrorLogRequestBody) {
        return (await this.httpClient.post(
            "/zeus/payment/error_log",
            body,
            {}
        )) as PostPaymentErrorLogResponseBody;
    }
    /**
     * Transition from in-app purchases to card payments
     */
    async postTransferToCard(body: PostTransferToCardRequestBody) {
        return (await this.httpClient.post(
            "/zeus/payment/transfer_to_card",
            body,
            {}
        )) as PostTransferToCardResponseBody;
    }
    /**
     * Cancel Transition from in-app purchases to card payments
     */
    async putCancelTransferToCard() {
        return (await this.httpClient.put(
            "/zeus/payment/cancel_transfer_to_card",
            {},
            {}
        )) as PutCancelTransferToCardResponseBody;
    }
    /**
     * Start 3DS authentication (for new card / per-transaction)
     */
    async postThreeDSecureEnroll(body: PostThreeDSecureEnrollRequestBody) {
        return (await this.httpClient.post(
            "/zeus/3ds/enroll",
            body,
            {}
        )) as PostThreeDSecureEnrollResponseBody;
    }
    /**
     * Execute 3DS payment (for new card / per-transaction)
     */
    async postThreeDSecurePay(body: PostThreeDSecurePayRequestBody) {
        return (await this.httpClient.post(
            "/zeus/3ds/pay",
            body,
            {}
        )) as PostThreeDSecurePayResponseBody;
    }
    /**
     * Start 3DS authentication (for recurring payment)
     */
    async postThreeDSecureQuickEnroll(
        body: PostThreeDSecureQuickEnrollRequestBody
    ) {
        return (await this.httpClient.post(
            "/zeus/3ds/quick/enroll",
            body,
            {}
        )) as PostThreeDSecureQuickEnrollResponseBody;
    }
    /**
     * Execute 3DS payment (for recurring payment)
     */
    async postThreeDSecureQuickPay(body: PostThreeDSecureQuickPayRequestBody) {
        return (await this.httpClient.post(
            "/zeus/3ds/quick/pay",
            body,
            {}
        )) as PostThreeDSecureQuickPayResponseBody;
    }
    /**
     * Get Payment Status
     */
    async getPaymentStatus() {
        return (await this.httpClient.get(
            "/payment/status",
            {}
        )) as GetPaymentStatusResponseBody;
    }
    /**
     * Register Payment Address
     */
    async registerPaymentAddress(body: RegisterPaymentAddressRequestBody) {
        return (await this.httpClient.post(
            "/payment/address",
            body,
            {}
        )) as RegisterPaymentAddressResponseBody;
    }
    /**
     * Put Stop paid membership
     */
    async putPaymentStopPaidMember() {
        return (await this.httpClient.put(
            "/payment/stop_paid_member",
            {},
            {}
        )) as PutPaymentStopPaidMemberResponseBody;
    }
    /**
     * Put Restart paid membership
     */
    async putPaymentRestartPaidMember() {
        return (await this.httpClient.put(
            "/payment/restart_paid_member",
            {},
            {}
        )) as PutPaymentRestartPaidMemberResponseBody;
    }
    /**
     * Get Search Banners
     */
    async getSearchBanners() {
        return (await this.httpClient.get(
            "/banners/for_search",
            {}
        )) as GetSearchBannersResponseBody;
    }
    /**
     * Get My Partner Condition
     */
    async getMyPartnerCondition() {
        return (await this.httpClient.get(
            "/partner_condition",
            {}
        )) as GetMyPartnerConditionResponseBody;
    }
    /**
     * Put My Partner Condition
     */
    async putMyPartnerCondition(body: PutMyPartnerConditionRequestBody) {
        return (await this.httpClient.put(
            "/partner_condition",
            body,
            {}
        )) as PutMyPartnerConditionResponseBody;
    }
    /**
     * Get Promotions
     */
    async getPromotions(query: GetPromotionsQuery) {
        return (await this.httpClient.get(
            "/promotion",
            query
        )) as GetPromotionsResponseBody;
    }
    /**
     * Get My Marriage Activity Status
     */
    async getMyMarriageActivityStatus() {
        return (await this.httpClient.get(
            "/marriage_activity_status",
            {}
        )) as GetMyMarriageActivityStatusResponseBody;
    }
    /**
     * Put My Marriage Activity Status
     */
    async putMyMarriageActivityStatus(
        body: PutMyMarriageActivityStatusRequestBody
    ) {
        return (await this.httpClient.put(
            "/marriage_activity_status",
            body,
            {}
        )) as PutMyMarriageActivityStatusResponseBody;
    }
}
